<template>
  <loader v-if="isLoader" />
  <div class="container-fluid" v-if="!isLoader">
    <!-- Header and Chart Row -->
    <div class="row">
      <!-- Header -->
      <div class="col-12 header">
        <div class="row">
          <div class="col-lg-3 logo-container">
              <a href="/#/" v-if="false" >
            <img
              src="@/assets/images/logo-lg-light.svg"
              alt="#"
              v-if="theme == 'light'"
            />
           </a>

             <a href="/#/" v-if="false" >
            <img
              src="@/assets/images/logo-lg-medium.svg"
              alt="#"
              v-if="theme == 'medium'"
            />
            </a>

              <a href="/#/" v-if="false" >
            <img
              src="@/assets/images/logo-lg-dark.svg"
              alt="#"
              v-if="theme == 'dark'"
            />
             </a>
          </div>
          <div class="col-lg-6 dash-heading-container">
            <h1 v-if="lang == 'ar'">لوحة أداء المشروع</h1>
            <h1 v-if="lang == 'en'">Project Dashboard</h1>
            <div class="line"></div>
          </div>
          <div class="col-lg-3 custom-dropdown-container">
             <div class="arrowlogo">
               <img 
              src="@/assets/images/arrow-h-dark.png"
              alt="#"
              v-if="theme == 'dark'"/>
              <img 
              src="@/assets/images/arrow-h-medium.png"
              alt="#"
              v-if="theme == 'medium'"/>
              <img 
              src="@/assets/images/arrow-h-light.png"
              alt="#"
              v-if="theme == 'light'"/>
            </div>
            <div class="togglers">
              <lang-toggler-v3></lang-toggler-v3>
              <theme-toggler-v3></theme-toggler-v3>
            </div>
          </div>
        </div>
      </div>
      <div
        class="col-12 information-tiles-section"
        v-if="projectData.project.length != 0"
      >
        <div class="lg-tile-proto">
          <div class="tilehead">
            <!-- <img src="@/assets/images/icons/v3-dollar-dark.svg" alt="#" /> -->
            <h1 v-if="lang == 'ar'">المعلومات الأساسية</h1>
            <h1 v-if="lang == 'en'">Basic Information</h1>
          </div>
          <div class="content-container">
            <div class="row">
              <div class="col-4">
                <div class="information">
                  <img src="@/assets/images/icons/project-name.svg" alt="#" />
                  <h1 v-if="lang == 'ar'">اسم المشروع</h1>
                  <h1 v-if="lang == 'en'">Project Name</h1>

                  <h3 :title="projectData.project[0].ProjectName"  >{{ projectData.project[0].ProjectName }}</h3>
                </div>
              </div>
              <div class="col-4">
                <div class="information">
                  <img
                    src="@/assets/images/icons/project-manager.svg"
                    alt="#"
                  />
                  <h1 v-if="lang == 'ar'">مدير المشروع</h1>
                  <h1 v-if="lang == 'en'">Project Manager</h1>
                  <h3 :title="projectData.project[0].ProjectManager">{{ projectData.project[0].ProjectManager }}</h3>
                </div>
              </div>
              <div class="col-4">
                <div class="information">
                  <img
                    src="@/assets/images/icons/project-sponser.svg"
                    alt="#"
                  />
                  <h1 v-if="lang == 'ar'">مالك المشروع</h1>
                  <h1 v-if="lang == 'en'">Project Sponser</h1>
                  <h3 :title="projectData.project[0].ProjectOwner1 ">{{ projectData.project[0].ProjectOwner1 }}</h3>
                </div>
              </div>
              <div class="col-4">
                <div class="information">
                  <img src="@/assets/images/icons/department.svg" alt="#" />
                  <h1 v-if="lang == 'ar'">الإدارة</h1>
                  <h1 v-if="lang == 'en'">Department</h1>
                  <h3 :title="projectData.project[0].Department">{{ projectData.project[0].Department }}</h3>
                </div>
              </div>
              <div class="col-4">
                <div class="information">
                  <img
                    src="@/assets/images/icons/approved-budget-sm.svg"
                    alt="#"
                  />
                  <h1 v-if="lang == 'ar'">قيمة العقد</h1>
                  <h1 v-if="lang == 'en'">Contract Value</h1>
                  <h3>
                    {{ numeralFormatter(projectData.project[0].ContractValue) }}
                  </h3>
                </div>
              </div>
              <div class="col-4">
                <div class="information">
                  <img
                    src="@/assets/images/icons/project-sponser.svg"
                    alt="#"
                  />
                  <h1 v-if="lang == 'ar'">(IT) مدير المشروع</h1>
                  <h1 v-if="lang == 'en'">Project Manager (IT)</h1>
                  <h3 :title="projectData.project[0].ProjectOfficerContact">{{ projectData.project[0].ProjectOfficerContact }}</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="lg-tile-proto">
          <div class="tilehead">
            <!-- <img src="@/assets/images/icons/v3-dollar-dark.svg" alt="#" /> -->
            <h1 v-if="lang == 'ar'">المعلومات الأساسية</h1>
            <h1 v-if="lang == 'en'">Basic Information</h1>
          </div>
          <div class="content-container">
            <div class="row">
              <div class="col-4">
                <div class="information">
                  <img src="@/assets/images/icons/calendar.svg" alt="#" />
                  <h1 v-if="lang == 'ar'">تاريخ البدء</h1>
                  <h1 v-if="lang == 'en'">Start Date</h1>
                  <h3>
                    {{ getOnlyDate(projectData.project[0].ProjectStartDate) }}
                  </h3>
                </div>
              </div>

              <div class="col-4">
                <div class="information">
                  <img src="@/assets/images/icons/calendar.svg" alt="#" />
                  <h1 v-if="lang == 'ar'">تاريخ الإنتهاء</h1>
                  <h1 v-if="lang == 'en'">Finish Date</h1>
                  <h3>
                    {{ getOnlyDate(projectData.project[0].ProjectFinishDate) }}
                  </h3>
                </div>
              </div>
              <div class="col-4">
                <div class="information">
                  <img
                    src="@/assets/images/icons/approved-budget-sm.svg"
                    alt="#"
                  />
                  <h1 v-if="lang == 'ar'">الميزانية التقديرية</h1>
                  <h1 v-if="lang == 'en'">Expected Budget</h1>
                  <h3>
                    {{
                      numeralFormatter(projectData.project[0].EstimatedBudget)
                    }}
                  </h3>
                </div>
              </div>
              <div class="col-4">
                <div class="information">
                  <img src="@/assets/images/icons/calendar.svg" alt="#" />
                  <h1 v-if="lang == 'ar'">تاريخ البدء المخطط</h1>
                  <h1 v-if="lang == 'en'">Baseline Start Date</h1>
                  <h3>
                    {{ getOnlyDate(projectData.project[0].ProjectStartDate) }}
                  </h3>
                </div>
              </div>
              <div class="col-4">
                <div class="information">
                  <img src="@/assets/images/icons/calendar.svg" alt="#" />
                  <h1 v-if="lang == 'ar'">تاريخ الإنتهاء المخطط</h1>
                  <h1 v-if="lang == 'en'">Baseline Finish Date</h1>
                  <h3>
                    {{ getOnlyDate(projectData.project[0].ProjectFinishDate) }}
                  </h3>
                </div>
              </div>

              <div class="col-4">
                <div class="information">
                  <img
                    src="@/assets/images/icons/approved-budget-sm.svg"
                    alt="#"
                  />
                  <h1 v-if="lang == 'ar'">الميزانية المعتمدة</h1>
                  <h1 v-if="lang == 'en'">Approved Budget</h1>
                  <h3>
                    {{
                      numeralFormatter(projectData.project[0].ApprovedBudget)
                    }}
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 tiles-section" v-if="projectData.project.length != 0">
        <div class="lg-tile-proto">
          <div class="tilehead">
            <!-- <img src="@/assets/images/icons/v3-dollar-dark.svg" alt="#" /> -->
            <h1 v-if="lang == 'ar'">نسبة الأنجاز</h1>
            <h1 v-if="lang == 'en'">Schedule Performance</h1>
          </div>
          <div class="content-container">
            <div class="tile-icon">
              <img src="@/assets/images/icons/calendar-tile.svg" alt="#" />
            </div>
            <div class="chart-holder">
              <circular-progress-v3
                id="cirp-2"
                :per="projectData.project[0].ActualCompletePercent"
                name="اجمالي العقود"
              />
            </div>
            <div class="list-holder block">
              <div class="list block">
                <img
                  src="@/assets/images/icons/planned.svg"
                  alt="#"
                  class="first"
                />
                <h1 v-if="lang == 'ar'">الفعلي</h1>
                <h1 v-if="lang == 'en'">Actual</h1>
                <h2>{{ projectData.project[0].ActualCompletePercent }}%</h2>
              </div>
              <div class="list block">
                <img src="@/assets/images/icons/actual.svg" alt="#" />

                <h1 v-if="lang == 'ar'">المخطط</h1>
                <h1 v-if="lang == 'en'">Planned</h1>
                <h2>{{ projectData.project[0].PlannedCompletePercent }}%</h2>
              </div>
            </div>
          </div>
        </div>
        <div class="lg-tile-proto">
          <div class="tilehead">
            <!-- <img src="@/assets/images/icons/v3-dollar-dark.svg" alt="#" /> -->
            <h1 v-if="lang == 'ar'">الميزانية</h1>
            <h1 v-if="lang == 'en'">Budget</h1>
          </div>
          <div class="content-container">
            <div class="tile-icon">
              <img src="@/assets/images/icons/dollar-watch.svg" alt="#" />
            </div>
            <div class="chart-holder">
              <circular-progress-v3
                id="cirp-1"
                :per="
                  projectData.project[0].ApprovedBudget == 0
                    ? 0
                    : (parseInt(projectData.project[0].PaidAmount) /
                        projectData.project[0].ApprovedBudget) *
                      100
                "
                name="اجمالي العقود"
              />
            </div>
            <div class="list-holder">
              <div class="list">
                <img
                  src="@/assets/images/icons/planned.svg"
                  alt="#"
                  class="first"
                />
                <h1 v-if="lang == 'ar'">المنصرف</h1>
                <h1 v-if="lang == 'en'">Spent</h1>
                <h2>
                  {{ numeralFormatter(projectData.project[0].PaidAmount) }}
                </h2>
              </div>
              <div class="list">
                <img src="@/assets/images/icons/actual.svg" alt="#" />

                <h1 v-if="lang == 'ar'">المعتمد</h1>
                <h1 v-if="lang == 'en'">Approved</h1>
                <h2>
                  {{ numeralFormatter(projectData.project[0].ApprovedBudget) }}
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 6 X 6 -->
    <div class="row">
      <div class="col-lg-6 milestones">
        <h1 class="table-title" v-if="lang == 'ar'">
          <img src="@/assets/images/icons/milestones.svg" alt="#" />
          المعالم
          <span class="current-filters" v-if="filter.milestones != 'all'">
            <span class="active-filter">{{ filter.milestones }}</span>
            <img
              src="@/assets/images/icons/close-filter.svg"
              alt="#"
              v-if="theme == 'dark' || theme == 'medium'"
              @click="deactivateMilestonesFilter()"
            />
            <img
              src="@/assets/images/icons/close-filter-light.svg"
              alt="#"
              v-if="theme == 'light'"
              @click="deactivateMilestonesFilter()"
            />
          </span>
        </h1>
        <h1 class="table-title" v-if="lang == 'en'">
          <img src="@/assets/images/icons/milestones.svg" alt="#" />
          Milestones
          <span class="current-filters" v-if="filter.milestones != 'all'">
            <span class="active-filter">{{ filter.milestones }}</span>
            <img
              src="@/assets/images/icons/close-filter.svg"
              alt="#"
              v-if="theme == 'dark' || theme == 'medium'"
              @click="deactivateMilestonesFilter()"
            />
            <img
              src="@/assets/images/icons/close-filter-light.svg"
              alt="#"
              v-if="theme == 'light'"
              @click="deactivateMilestonesFilter()"
            />
          </span>
        </h1>
        <div
          v-if="false"
          :class="
            filter.milestones == 'حسب المخطط'
              ? 'table-tiles active'
              : 'table-tiles'
          "
          @click="filterMilestones('حسب المخطط')"
        >
          <img src="@/assets/images/icons/nonimpact.svg" alt="#" class="icon" />
          <h1 v-if="lang == 'ar'">حسب المخطط</h1>
          <h1 v-if="lang == 'en'">On Planned</h1>
          <h2>
            {{
              projectData.milestones.filter(
                (item) => item.TaskStatus == "حسب المخطط"
              ).length
            }}
          </h2>
        </div>
        <div
          v-if="false"
          :class="
            filter.milestones == 'مكتمل' ? 'table-tiles active' : 'table-tiles'
          "
          @click="filterMilestones('مكتمل')"
        >
          <img
            src="@/assets/images/icons/less.svg"
            alt="#"
            class="icon"
            v-if="theme == 'dark'"
          />
          <img
            src="@/assets/images/icons/v3-risk-low.svg"
            alt="#"
            class="icon"
            v-if="theme == 'medium' || theme == 'light'"
          />
          <h1 v-if="lang == 'ar'">مكتمل</h1>
          <h1 v-if="lang == 'en'">Completed</h1>
          <h2>
            {{
              projectData.milestones.filter(
                (item) => item.TaskStatus == "مكتمل"
              ).length
            }}
          </h2>
        </div>
        <div
          v-if="false"
          :class="
            filter.milestones == 'متوقع التأخير'
              ? 'table-tiles active'
              : 'table-tiles'
          "
          @click="filterMilestones('متوقع التأخير')"
        >
          <img src="@/assets/images/icons/moderate.svg" alt="#" class="icon" />
          <h1 v-if="lang == 'ar'">متوقع التأخير</h1>
          <h1 v-if="lang == 'en'">Expected Late</h1>
          <h2>
            {{
              projectData.milestones.filter(
                (item) => item.TaskStatus == "متوقع التأخير"
              ).length
            }}
          </h2>
        </div>
        <div
          v-if="false"
          :class="
            filter.milestones == 'متأخر'
              ? 'table-tiles active last'
              : 'table-tiles last'
          "
          @click="filterMilestones('متأخر')"
        >
          <img src="@/assets/images/icons/veryhigh.svg" alt="#" class="icon" />
          <h1 v-if="lang == 'ar'">متأخر</h1>
          <h1 v-if="lang == 'en'">Late</h1>
          <h2>
            {{
              projectData.milestones.filter(
                (item) => item.TaskStatus == "متأخر"
              ).length
            }}
          </h2>
        </div>

        <table class="milestone-table">
          <thead>
            <tr v-if="lang == 'ar'">
              <th>الاسم</th>
              <th>تاريخ البدء</th>
              <th>تاريخ الإنتهاء</th>
              <th>تاريخ البدء المخطط</th>
              <th>تاريخ الإنتهاء المخطط</th>
              <th class="center">الحالة</th>
              <th class="center">% النسبة</th>
            </tr>
            <tr v-if="lang == 'en'">
              <th>Name</th>
              <th>Start Date</th>
              <th>Finish Date</th>
              <th>Baseline Start Date</th>
              <th>Baseline Finish Date</th>
              <th class="center">Status</th>
              <th class="center">% Completed</th>
            </tr>
          </thead>
          <tbody v-if="projectData.milestones.length > 0">
            <tr
              v-for="milestone in filteredMilestones"
              :key="milestone.ProjectUID"
            >
              <td>
                {{ milestone.TaskName }}
              </td>
              <td class="date">
                {{ getOnlyDate(milestone.TaskStartDate) }}
              </td>
              <td class="date">
                {{ getOnlyDate(milestone.TaskFinishDate) }}
              </td>
              <td class="date">
                {{
                  milestone.TaskBaseline0StartDate == null
                    ? "Not Found"
                    : getOnlyDate(milestone.TaskBaseline0StartDate)
                }}
              </td>
              <td class="date">
                {{
                  milestone.TaskBaseline0FinishDate == null
                    ? "Not Found"
                    : getOnlyDate(milestone.TaskBaseline0FinishDate)
                }}
              </td>
              <td class="center">
                <span class="late" v-if="milestone.TaskStatus == 'متأخر'">
                  {{ milestone.TaskStatus }}
                </span>
                <span
                  class="expectedlate"
                  v-if="milestone.TaskStatus == 'متوقع التأخير'"
                >
                  {{ milestone.TaskStatus }}
                </span>
                <span class="completed" v-if="milestone.TaskStatus == 'مكتمل'">
                  {{ milestone.TaskStatus }}
                </span>
                <span
                  class="onplanned"
                  v-if="milestone.TaskStatus == 'حسب المخطط'"
                >
                  {{ milestone.TaskStatus }}
                </span>
              </td>
              <td class="center">
                <span>
                  {{
                    milestone.TaskPercentCompleted == null
                      ? "0"
                      : milestone.TaskPercentCompleted
                  }}%
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-lg-6 deliverables">
        <h1 class="table-title" v-if="lang == 'ar'">
          <img src="@/assets/images/icons/deliverables.svg" alt="#" />
          المخرجات
          <span class="current-filters" v-if="filter.deliverables != 'all'">
            <span class="active-filter">{{ filter.deliverables }}</span>
            <img
              src="@/assets/images/icons/close-filter.svg"
              alt="#"
              v-if="theme == 'dark' || theme == 'medium'"
              @click="deactivateDeliverablesFilter"
            />
            <img
              src="@/assets/images/icons/close-filter-light.svg"
              alt="#"
              v-if="theme == 'light'"
              @click="deactivateDeliverablesFilter"
            />
          </span>
        </h1>
        <h1 class="table-title" v-if="lang == 'en'">
          <img src="@/assets/images/icons/deliverables.svg" alt="#" />
          Deliverables
          <span class="current-filters" v-if="filter.deliverables != 'all'">
            <span class="active-filter">{{ filter.deliverables }}</span>
            <img
              src="@/assets/images/icons/close-filter.svg"
              alt="#"
              v-if="theme == 'dark' || theme == 'medium'"
              @click="deactivateDeliverablesFilter"
            />
            <img
              src="@/assets/images/icons/close-filter-light.svg"
              alt="#"
              v-if="theme == 'light'"
              @click="deactivateDeliverablesFilter"
            />
          </span>
        </h1>

        <div
          v-if="false"
          :class="
            filter.deliverables == 'حسب المخطط'
              ? 'table-tiles active'
              : 'table-tiles'
          "
          @click="filterDeliverables('حسب المخطط')"
        >
          <img src="@/assets/images/icons/nonimpact.svg" alt="#" class="icon" />
          <h1 v-if="lang == 'ar'">حسب المخطط</h1>
          <h1 v-if="lang == 'en'">On Planned</h1>
          <h2>
            {{
              projectData.deliverables.filter(
                (item) => item.TaskStatus == "حسب المخطط"
              ).length
            }}
          </h2>
        </div>
        <div
          v-if="false"
          :class="
            filter.deliverables == 'مكتمل'
              ? 'table-tiles active'
              : 'table-tiles'
          "
          @click="filterDeliverables('مكتمل')"
        >
          <img
            src="@/assets/images/icons/less.svg"
            alt="#"
            class="icon"
            v-if="theme == 'dark'"
          />
          <img
            src="@/assets/images/icons/v3-risk-low.svg"
            alt="#"
            class="icon"
            v-if="theme == 'medium' || theme == 'light'"
          />
          <h1 v-if="lang == 'ar'">مكتمل</h1>
          <h1 v-if="lang == 'en'">Completed</h1>
          <h2>
            {{
              projectData.deliverables.filter(
                (item) => item.TaskStatus == "مكتمل"
              ).length
            }}
          </h2>
        </div>
        <div
          v-if="false"
          :class="
            filter.deliverables == 'متوقع التأخير'
              ? 'table-tiles active'
              : 'table-tiles'
          "
          @click="filterDeliverables('متوقع التأخير')"
        >
          <img src="@/assets/images/icons/moderate.svg" alt="#" class="icon" />
          <h1 v-if="lang == 'ar'">متوقع التأخير</h1>
          <h1 v-if="lang == 'en'">Expected Late</h1>
          <h2>
            {{
              projectData.deliverables.filter(
                (item) => item.TaskStatus == "متوقع التأخير"
              ).length
            }}
          </h2>
        </div>
        <div
          v-if="false"
          :class="
            filter.deliverables == 'متأخر'
              ? 'table-tiles active last'
              : 'table-tiles last'
          "
          @click="filterDeliverables('متأخر')"
        >
          <img src="@/assets/images/icons/veryhigh.svg" alt="#" class="icon" />
          <h1 v-if="lang == 'ar'">متأخر</h1>
          <h1 v-if="lang == 'en'">Late</h1>
          <h2>
            {{
              projectData.deliverables.filter(
                (item) => item.TaskStatus == "متأخر"
              ).length
            }}
          </h2>
        </div>

        <table class="deliverable-table">
          <thead>
            <tr v-if="lang == 'ar'">
              <th>الاسم</th>
              <th>تاريخ البدء</th>
              <th>تاريخ الإنتهاء</th>
              <th v-if="false">تاريخ البدء المخطط</th>
              <th v-if="false">تاريخ الإنتهاء المخطط</th>
              <th v-if="false" class="center">الحالة</th>
              <th class="center">% النسبة</th>
            </tr>
            <tr v-if="lang == 'en'">
              <th>Name</th>
              <th>Start Date</th>
              <th>Finish Date</th>
              <th v-if="false">Baseline Start Date</th>
              <th v-if="false">Baseline Finish Date</th>
              <th v-if="false" class="center">Status</th>
              <th class="center">% Completed</th>
            </tr>
          </thead>
          <tbody v-if="projectData.deliverables.length > 0">
            <tr
              v-for="deliverable in filteredDeliverables"
              :key="deliverable.ProjectUID"
            >
              <td>
                {{ deliverable.Title }}
              </td>
              <td class="date">
                {{ getOnlyDate(deliverable.StartDate) }}
              </td>
              <td class="date">
                {{ getOnlyDate(deliverable.FinishDate) }}
              </td>
              <td v-if="false" class="date">
                {{
                  deliverable.TaskBaseline0StartDate == null
                    ? "Not Found"
                    : getOnlyDate(deliverable.TaskBaseline0StartDate)
                }}
              </td>
              <td v-if="false" class="date">
                {{
                  deliverable.TaskBaseline0FinishDate == null
                    ? "Not Found"
                    : getOnlyDate(deliverable.TaskBaseline0FinishDate)
                }}
              </td>
              <td v-if="false" class="center">
                <span class="late" v-if="deliverable.TaskStatus == 'متأخر'">
                  {{ deliverable.TaskStatus }}
                </span>
                <span
                  class="expectedlate"
                  v-if="deliverable.TaskStatus == 'متوقع التأخير'"
                >
                  {{ deliverable.TaskStatus }}
                </span>
                <span
                  class="completed"
                  v-if="deliverable.TaskStatus == 'مكتمل'"
                >
                  {{ deliverable.TaskStatus }}
                </span>
                <span
                  class="onplanned"
                  v-if="deliverable.TaskStatus == 'حسب المخطط'"
                >
                  {{ deliverable.TaskStatus }}
                </span>
              </td>
              <td class="center">
                <span>
                  {{
                    deliverable.TaskPercentCompleted == null
                      ? "0"
                      : deliverable.TaskPercentCompleted
                  }}%
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- 6*6 Tables -->
    <div class="row">
      <div class="col-lg-12 risks">
        <h1 class="table-title" v-if="lang == 'ar'">المخاطر</h1>
        <h1 class="table-title" v-if="lang == 'en'">Risks</h1>
        <div
          :class="filter.risk == 'all' ? 'table-tiles active' : 'table-tiles'"
          @click="filterRisks('all')"
        >
          <img
            src="@/assets/images/icons/all.svg"
            alt="#"
            class="icon"
            v-if="theme == 'light'"
          />
          <img
            src="@/assets/images/icons/v3-risk-all.svg"
            alt="#"
            class="icon"
            v-if="theme == 'medium'"
          />
          <img
            src="@/assets/images/icons/all-dark.svg"
            alt="#"
            class="icon"
            v-if="theme == 'dark'"
          />

          <h1 v-if="lang == 'ar'">الكل</h1>
          <h1 v-if="lang == 'en'">All</h1>
          <h2>{{ projectData.risks.length }}</h2>
        </div>
        <div
          :class="filter.risk == '5' ? 'table-tiles active' : 'table-tiles'"
          @click="filterRisks('5')"
        >
          <img src="@/assets/images/icons/veryhigh.svg" alt="#" class="icon" />
          <h1 v-if="lang == 'ar'">خطير جدا</h1>
          <h1 v-if="lang == 'en'">Very High</h1>
          <h2>
            {{ projectData.risks.filter((item) => item.Exposure >= 5).length }}
          </h2>
        </div>
        <div
          :class="filter.risk == '4' ? 'table-tiles active' : 'table-tiles'"
          @click="filterRisks('4')"
        >
          <img src="@/assets/images/icons/high.svg" alt="#" class="icon" />
          <h1 v-if="lang == 'ar'">خطير</h1>
          <h1 v-if="lang == 'en'">High</h1>
          <h2>
            {{ projectData.risks.filter((item) => item.Exposure == 4).length }}
          </h2>
        </div>
        <div
          :class="filter.risk == '3' ? 'table-tiles active' : 'table-tiles'"
          @click="filterRisks('3')"
        >
          <img src="@/assets/images/icons/moderate.svg" alt="#" class="icon" />
          <h1 v-if="lang == 'ar'">متوسط</h1>
          <h1 v-if="lang == 'en'">Medium</h1>
          <h2>
            {{ projectData.risks.filter((item) => item.Exposure == 3).length }}
          </h2>
        </div>
        <div
          :class="filter.risk == '2' ? 'table-tiles active' : 'table-tiles'"
          @click="filterRisks('2')"
        >
          <img
            src="@/assets/images/icons/less.svg"
            alt="#"
            class="icon"
            v-if="theme == 'dark'"
          />
          <img
            src="@/assets/images/icons/v3-risk-low.svg"
            alt="#"
            class="icon"
            v-if="theme == 'medium' || theme == 'light'"
          />
          <h1 v-if="lang == 'ar'">خفيف</h1>
          <h1 v-if="lang == 'en'">Low</h1>
          <h2>
            {{ projectData.risks.filter((item) => item.Exposure == 2).length }}
          </h2>
        </div>
        <div
          :class="
            filter.risk == '1' ? 'table-tiles active last' : 'table-tiles last'
          "
          @click="filterRisks('1')"
        >
          <img
            src="@/assets/images/icons/nonimpact.svg"
            alt="#"
            class="icon"
            v-if="theme == 'dark'"
          />
          <img
            src="@/assets/images/icons/nonimpact.svg"
            alt="#"
            class="icon"
            v-if="theme == 'medium' || theme == 'light'"
          />
          <h1 v-if="lang == 'ar'">غير مؤثر</h1>
          <h1 v-if="lang == 'en'">No Impact</h1>
          <h2>
            {{ projectData.risks.filter((item) => item.Exposure == 0).length }}
          </h2>
        </div>

        <table class="risk-table">
          <thead>
            <tr>
              <th v-if="lang == 'ar'">اسم الخطر</th>
              <th v-if="lang == 'en'">Title</th>
              <th v-if="lang == 'ar'">اسم المشروع</th>
              <th v-if="lang == 'en'">Project Name</th>
              <th v-if="lang == 'ar'">نوع الخطر</th>
              <th v-if="lang == 'en'">Type</th>
              <th v-if="lang == 'ar'">القطاع</th>
              <th v-if="lang == 'en'">Sector</th>
              <th class="center" v-if="lang == 'ar'">التأثير</th>
              <th class="center" v-if="lang == 'en'">Exposure</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="risk in filteredRisks" :key="risk.status">
              <td>{{ risk.RiskTitle }}</td>
              <td>{{ risk.ProjectName }}</td>
              <td>{{ risk.RiskType }}</td>
              <td>{{ risk.القطاع }}</td>
              <td class="center">
                <span v-if="risk.Exposure == '1'" class="low"> غير مؤثر </span>
                <span v-if="risk.Exposure == '2'" class="low">
                  تأثير خفيف
                </span>
                <span v-if="risk.Exposure == '3'" class="medium"> متوسط </span>
                <span v-if="risk.Exposure == '4'" class="high"> خطير </span>
                <span v-if="risk.Exposure >= '5'" class="high"> خطير جدا </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <FooterUnfixed/>

  </div>
</template>





<script>
// Dependences
import store from "@/store";
// import Swal from 'sweetalert2'
import axios from "axios"; //uncomment when using api

// Components
import Loader from "@/components/outer-section-v2.vue";
import CircularProgressV3 from "@/components/charts/circular-progress-v3.vue";
import ThemeTogglerV3 from "@/components/theme-toggler-v3.vue";
import LangTogglerV3 from "@/components/lang-toggler-v3.vue";
import FooterUnfixed from "@/components/footer-unfixed.vue";


// import $ from 'jquery';

// Local data fetch for testign
import { projects } from "@/static/projectdataset.js";
import { risks } from "@/static/riskprojects.js";
import { deliverables } from "@/static/deliverables.js";
import { milestones } from "@/static/milestones.js";

export default {
  name: "ProjectAR-dev",
  components: {
    Loader,
    CircularProgressV3,
    ThemeTogglerV3,
    LangTogglerV3,
    FooterUnfixed

  },
  computed: {
    theme() {
      return store.getters.getCurrentTheme;
    },
    lang() {
      return store.getters.getCurrentLang;
    },
    env() {
      return store.getters.getEnv;
    },
    filteredProjects() {
      return store.getters.getFilteredProjects;
    },
    activeTab() {
      return store.getters.getActiveTab;
    },
    activeFilter() {
      return store.getters.getActiveFilter;
    },
  },
  data() {
    return {
      isLoader: false,
      selectedProject: this.$route.query.id,
      filteredRisks: null,
      filteredMilestones: null,
      filteredDeliverables: null,
      filter: {
        risk: "all",
        issue: "all",
        milestones: "all",
        deliverables: "all",
      },
      fireSwal: false,
      projectData: {
        risks: [],
        project: [],
        deliverables: [],
        milestones: [],
        tileView: true,
        tableView: false,
        risk: {
          veryHigh: 0,
          high: 0,
          moderate: 0,
          low: 0,
          nonImpact: 0,
        },
      },
    };
  },
  methods: {
    numeralFormatter: function (number) {
      if (number == null) {
        number = 0;
      }
      number = number.toString().replace(/,/g, "");

      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "sar",
        minimumFractionDigits: 0,
      });
      if (number < 1000000 && number > 1000) {
        // Anything less than a million
        return formatter.format(number) + "K";
      } else if (number < 1000000000 && number > 1000000) {
        // Anything less than a billion
        number = number / 1000000;
        return formatter.format(number) + "M";
      } else if (number > 1000000000) {
        // At least a billion
        number = number / 1000000000;
        return formatter.format(number) + "B";
      } else {
        return formatter.format(number);
      }
    },
    getOnlyDate: function (dateTime) {
      let date = new Date(dateTime);
      let year = date.getFullYear();
      let month =
        date.getMonth().toString().length > 1
          ? date.getMonth()
          : "0" + date.getMonth();
      let day =
        date.getDate().toString().length > 1
          ? date.getDate()
          : "0" + date.getDate();
      month = parseInt(month) + 1;
      let dateWithoutTime = day + "-" + month + "-" + year;
      return dateWithoutTime;
    },
    filterRisks: function (filter) {
      this.filter.risk = filter;
      if (filter == "all") {
        this.filteredRisks = this.projectData.risks;
      } else {
        this.filteredRisks = this.projectData.risks.filter(
          (item) => item.Exposure == filter
        );
      }
    },
    filterMilestones: function (filter) {
      this.filter.milestones = filter;
      if (filter == "all") {
        this.filteredMilestones = this.projectData.milestones;
      } else {
        this.filteredMilestones = this.projectData.milestones.filter(
          (item) => item.TaskStatus == filter
        );
      }
    },
    filterDeliverables: function (filter) {
      this.filter.deliverables = filter;
      if (filter == "all") {
        this.filteredDeliverables = this.projectData.deliverables;
      } else {
        this.filteredDeliverables = this.projectData.deliverables.filter(
          (item) => item.TaskStatus == filter
        );
      }
    },
    deactivateDeliverablesFilter: function () {
      this.filter.deliverables = "all";
      this.filteredDeliverables = this.projectData.deliverables;
    },
    deactivateMilestonesFilter: function () {
      this.filter.milestones = "all";
      this.filteredMilestones = this.projectData.milestones;
    },
  },
  async mounted() {
    

    // Fetching from api uncomment below three lines if using api
    if (this.env == "prod") {
      try {
        this.isLoader = true;
        const response = await axios.get(
          `https://pmoapi.sdb.gov.sa/api/proj/5/${this.selectedProject}`,

          { withCredentials: true }
        );
        this.projectData.project = JSON.parse(response.data[0]).filter(
          (item) => item.ProjectUID == this.selectedProject
        );
        this.projectData.risks = JSON.parse(response.data[1]).filter(
          (item) => item.ProjectUID == this.selectedProject
        );
        this.projectData.deliverables = JSON.parse(response.data[2]).filter(
          (item) => item.ProjectUID == this.selectedProject
        );
        this.projectData.milestones = JSON.parse(response.data[3]).filter(
          (item) => item.ProjectUID == this.selectedProject
        );
        this.isLoader = false;
      } catch (error) {
        console.log(error);
      }
    }

    if (this.env == "dev") {
      console.log(
        `https://pmoapi.sdb.gov.sa/api/proj/5&id=${this.selectedProject}`
      );
      // Fetching from local comment below three lines if using api
      this.projectData.project = projects.filter(
        (item) => item.ProjectUID == this.selectedProject
      );
      this.projectData.risks = risks.filter(
        (item) => item.ProjectUID == this.selectedProject
      );
      this.projectData.deliverables = deliverables.filter(
        (item) => item.ProjectUID == this.selectedProject
      );
      this.projectData.milestones = milestones.filter(
        (item) => item.ProjectUID == this.selectedProject
      );
    }

    this.filteredRisks = this.projectData.risks;
    this.filteredMilestones = this.projectData.milestones;
    this.filteredDeliverables = this.projectData.deliverables;

    setTimeout(function() {
      const contt = document.querySelectorAll('.information h3');

      contt.forEach(function(item){
        if(item.innerHTML.length >=37) {
          item.innerHTML = item.innerHTML.substring(0,30) + '...';
        }
      });
      // console.log(contt[1].innerHTML.length);
     


    },1000);
  },  
};
</script>

<style lang="scss">
@import "@/assets/css/global.scss";

body.ar {
  direction: rtl;
}
body.en {
  direction: ltr;
}

body.theme-light {
  background: $primary-background-light-v3;
}
body.theme-dark {
  background: $primary-background-dark-v3;
}
body.theme-medium {
  background: $primary-background-medium-v3;
}
</style>

<style lang="scss" scoped>
@import "@/assets/css/global.scss";
@import "@/assets/css/common.scss";

.theme-dark.ar {
  .information-tiles-section {
    display: inline-flex;
    justify-content: space-between;
    padding-top: 25px;
    padding-bottom: 32px;
    border-bottom: 1px dashed $v3-dark-dashed-seperator;
    .lg-tile-proto {
      width: 648px;
      height: 260px;
      border-radius: 13px;
      position: relative;
      @include applyGradientBorderDarkV3;
      box-shadow: 0px 11px 81px rgba(0, 0, 0, 0.26);

      .tilehead {
        height: 67px;
        background: $v3-dark-header-color;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        border-radius: 13px 13px 0px 0px;
        box-shadow: 0px 11px 81px rgba(0, 0, 0, 0.26);

        img {
          margin-left: 15px;
          margin-right: 15px;
        }

        h1 {
          @include apply-font($almarai, 400, 14px, $v3-dark-primarytext);
        }

        h1:last-child {
          margin-bottom: 0px;
        }
      }

      .content-container {
        display: inline-flex;
        justify-content: space-between;
        flex-wrap: wrap;
        align-items: center;
        padding-top: 20px;
        padding-bottom: 20px;
        padding-left: 25px;
        padding-right: 15px;

        .information {
          margin-bottom: 20px;
          position: relative;
          padding-right: 50px;
          img {
            position: absolute;
            right: 0px;
            top: 0px;
          }
          h1 {
            @include apply-font($almarai, 400, 14px, #1ab1c7);
            margin-bottom: 10px;
          }
          h3 {
            @include apply-font($almarai, 400, 14px, $v3-dark-primarytext);
        
          }
        }
      }
    }
    .information-tile {
      width: 282px;
      height: 162px;
      border-radius: 13px;
      position: relative;
      @include applyGradientBorderDarkV3;
      box-shadow: 0px 11px 81px rgba(0, 0, 0, 0.26);
      margin-left: 30px;
      margin-bottom: 30px;

      &:nth-child(4n) {
        margin-left: 0;
      }

      .tilehead {
        height: 67px;
        background: $v3-dark-header-color;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        border-radius: 13px 13px 0px 0px;
        box-shadow: 0px 11px 81px rgba(0, 0, 0, 0.26);

        img {
          margin-left: 15px;
          margin-right: 15px;
        }

        h1 {
          @include apply-font($almarai, 400, 14px, $v3-dark-primarytext);
        }

        h1:last-child {
          margin-bottom: 0px;
        }
      }
      .content-container {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        height: 100px;
        text-align: center;
        p {
          @include apply-font($almarai, 600, 19px, $v3-dark-primarytext);
          margin-bottom: 0;
        }
        p.last {
          @include apply-font($almarai, 600, 13px, $v3-dark-primarytext);
        }
      }
    }
  }
  .tiles-section {
    display: flex;
    justify-content: space-between;
    padding-top: 25px;
    padding-bottom: 32px;
    border-bottom: 1px dashed $v3-dark-dashed-seperator;

    .lg-tile-proto {
      width: 648px;
      height: 260px;
      border-radius: 13px;
      position: relative;
      @include applyGradientBorderDarkV3;
      box-shadow: 0px 11px 81px rgba(0, 0, 0, 0.26);

      .tilehead {
        height: 67px;
        background: $v3-dark-header-color;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        border-radius: 13px 13px 0px 0px;
        box-shadow: 0px 11px 81px rgba(0, 0, 0, 0.26);

        img {
          margin-left: 15px;
          margin-right: 15px;
        }

        h1 {
          @include apply-font($almarai, 400, 14px, $v3-dark-primarytext);
        }

        h1:last-child {
          margin-bottom: 0px;
        }
      }

      .content-container {
        display: inline-flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 20px;
        padding-bottom: 20px;
        padding-left: 25px;
        padding-right: 15px;

        .chart-holder {
          max-width: 153px;
          max-height: 140px;
          margin-right: 50px;
        }
        .tile-icon {
          img {
            margin-right: 30px;
          }
        }

        .tile-proto {
          width: 130px;
          height: 153px;
          border-radius: 13px;
          display: flex;
          align-items: center;
          flex-direction: column;
          position: relative;
          @include applyGradientBorderDarkV3;
          box-shadow: 0px 11px 81px rgba(0, 0, 0, 0.26);
          margin-left: 20px;

          img {
            margin-top: 0px;
          }

          h1 {
            @include apply-font($almarai, 700, 13px, #527a7a);
            margin-bottom: 0px;
            margin-top: 0px;
          }

          h2 {
            @include apply-font($sourcesanspro, 700, 33px, #1ab1c7);
            margin-bottom: 0px;
            margin-top: 15px;
          }

          h2.small {
            font-size: 19px !important;
            margin-top: 20px;
          }

          h2.purple {
            color: #1ab1c7 !important;
          }

          h2.green {
            color: #47bf8e !important;
          }
        }
        .list-holder.block {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .list.block {
          margin-right: 50px;
          padding-right: 20px;
          img {
            position: static;
            margin-bottom: 5px;
          }
        }

        .list {
          height: 70px;
          display: flex;
          justify-content: center;
          align-items: flex-start;
          flex-direction: column;
          position: relative;
          padding-right: 62px;
          margin-right: 50px;

          &:first-child {
            margin-top: 10px;
          }

          img {
            position: absolute;
            right: 0px;
            top: 15px;
          }
          img.first {
            right: 8px;
          }

          h1 {
            // letter-spacing: 1.91px;
            @include apply-font($almarai, 700, 13px, #1ab1c7);
            margin-bottom: 6px;
          }

          h2 {
            @include apply-font($sourcesanspro, 300, 16px, #fff);
            margin-bottom: 10px;
          }

          h2.blue {
            color: #1ab1c7 !important;
          }
        }

        .list.border-b {
          border-bottom: 1px solid rgba(0, 156, 181, 0.13);
        }
      }
    }
  }
  .milestones,
  .deliverables {
    height:500px;
    padding-top: 25px;
    padding-bottom: 32px;
    border-bottom: 1px dashed $v3-dark-dashed-seperator;
    overflow: auto;

    .current-filters {
      margin-right: 20px;
      .active-filter {
        @include apply-font($almarai, 700, 14px, $v3-dark-primarytext);
        border: 1px solid #fff;
        border-radius: 17.56px;
        padding: 8px 20px;
      }
      img {
        cursor: pointer;
        margin-top: 10px;
        margin-right: 20px;
      }
    }

    .table-title {
      @include apply-font($almarai, 300, 18px, $v3-dark-primarytext);
      margin-bottom: 36px;
      img {
        height: 15px;
        margin-left: 20px;
      }
    }

    .table-tiles {
      width: 142px;
      height: 67px;
      border-radius: 13px;
      position: relative;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      padding-top: 5px;
      // padding-bottom: 10px;
      margin-left: 28px;
      cursor: pointer;
      @include applyGradientBorderDarkV3;
      box-shadow: 0px 11px 81px rgba(0, 0, 0, 0.26);

      &.table-tiles.active {
        background: linear-gradient(
              152.47deg,
              $v3-dark-header-color 0.74%,
              #20384b 97.97%
            )
            padding-box,
          linear-gradient(
              140deg,
              rgba(171, 227, 227, 1),
              rgba(6, 26, 26, 0),
              rgba(170, 214, 214, 1)
            )
            border-box;
        box-shadow: 0px 11px 81px rgba(0, 0, 0, 0.83);
      }

      img.icon {
        position: absolute;
        right: 20px;
        top: 15px;
      }

      h1 {
        @include apply-font($almarai, 400, 14px, $v3-dark-primarytext);
        margin-right: 18px;
      }

      h2 {
        @include apply-font($sourcesanspro, 600, 26px, $v3-dark-primarytext);
        margin-right: 18px;
      }
    }

    .table-tiles.last {
      margin-left: 0;
    }

    .milestone-table,
    .deliverable-table {
      width: 96%;
      margin-top: 60px;

      thead {
        tr {
          background: #1978b2;
          height: 45px;
          // height: 63px;

          th {
            @include apply-font($almarai, 700, 12px, #fff);
          }
          th:first-child {
            padding-right: 10px;
          }

          th.center {
            text-align: center;
          }
        }
      }

      tbody {
        tr {
          height: 63px;
        }

        tr:nth-child(odd) {
          background: $v3-dark-table-stripes;
        }

        tr {
          td {
            @include apply-font($almarai, 400, 12px, $v3-dark-primarytext);
          }

          td:first-child {
            padding-right: 10px;
          }

          td.date,
          td.span {
            @include apply-font($almarai, 700, 12px, $v3-dark-primarytext);
          }

          td span {
            padding: 2px 25px;
            border-radius: 4px;
            color: #fff;
            white-space: nowrap;
          }

          td span.high {
            background: $v3-high;
          }

          td span.medium {
            background: $v3-medium;
          }

          td span.low {
            background: $v3-low;
          }
          td span.late {
            background: $v3-late;
          }

          td span.expectedlate {
            background: $v3-expectedlate;
          }

          td span.onplanned {
            background: $v3-onplanned;
          }
          td span.completed {
            background: $v3-completed;
          }

          td.center {
            text-align: center;
          }
        }
      }
    }
  }

  .deliverables {
    .table-tiles {
      img.icon {
        top: 20px;
      }
    }
  }
  .risks {
    padding-top: 25px;
    padding-bottom: 32px;
    border-bottom: 1px dashed $v3-dark-dashed-seperator;

    .table-title {
      @include apply-font($almarai, 700, 18px, $v3-dark-primarytext);
      margin-bottom: 36px;
    }

    .table-tiles {
      width: 142px;
      height: 67px;
      border-radius: 13px;
      position: relative;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      padding-top: 5px;
      // padding-bottom: 10px;
      margin-left: 28px;
      cursor: pointer;
      @include applyGradientBorderDarkV3;
      box-shadow: 0px 11px 81px rgba(0, 0, 0, 0.26);

      &.table-tiles.active {
        background: linear-gradient(
              152.47deg,
              $v3-dark-header-color 0.74%,
              #20384b 97.97%
            )
            padding-box,
          linear-gradient(
              140deg,
              rgba(171, 227, 227, 1),
              rgba(6, 26, 26, 0),
              rgba(170, 214, 214, 1)
            )
            border-box;
        box-shadow: 0px 11px 81px rgba(0, 0, 0, 0.83);
      }

      img.icon {
        position: absolute;
        right: 20px;
        top: 15px;
      }

      h1 {
        @include apply-font($almarai, 400, 14px, $v3-dark-primarytext);
        margin-right: 18px;
      }

      h2 {
        @include apply-font($sourcesanspro, 600, 26px, $v3-dark-primarytext);
        margin-right: 18px;
      }
    }

    .table-tiles.last {
      margin-left: 0;
    }

    .risk-table,
    .issue-table {
      width: 96%;
      margin-top: 60px;
      max-height: 693px;
      overflow: auto;

      thead {
        tr {
          height: 63px;

          th {
            @include apply-font($almarai, 700, 12px, #91b3ba);
          }

          th.center {
            text-align: center;
          }
        }
      }

      tbody {
        tr {
          height: 63px;
        }

        tr:nth-child(odd) {
          background: $v3-dark-table-stripes;
        }

        tr {
          td {
            @include apply-font($almarai, 400, 12px, $v3-dark-primarytext);
          }

          td:first-child {
            padding-right: 10px;
          }

          td.date,
          td.span {
            @include apply-font($almarai, 700, 12px, $v3-dark-primarytext);
          }

          td span {
            padding: 2px 25px;
            border-radius: 4px;
            color: #fff;
            white-space: nowrap;
          }

          td span.high {
            background: #ff6565;
          }

          td span.medium {
            background: #fa9963;
          }

          td span.low {
            background: #84ff90;
          }

          td.center {
            text-align: center;
          }
        }
      }
    }
  }
}
.theme-medium.ar {
  .information-tiles-section {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding-top: 25px;
    padding-bottom: 32px;
    border-bottom: 1px dashed $v3-medium-dashed-seperator;

    .lg-tile-proto {
      width: 648px;
      height: 260px;
      border-radius: 13px;
      position: relative;
      @include applyGradientBorderMediumV3;
      box-shadow: 17px 27px 44px rgba(0, 0, 0, 0.04);

      .tilehead {
        height: 67px;
        background: $v3-medium-header-color;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        border-radius: 13px 13px 0px 0px;
        box-shadow: 0px 11px 81px rgba(0, 0, 0, 0.26);

        img {
          margin-left: 15px;
          margin-right: 15px;
        }

        h1 {
          @include apply-font($almarai, 400, 14px, $v3-medium-primarytext);
        }

        h1:last-child {
          margin-bottom: 0px;
        }
      }

      .content-container {
        display: inline-flex;
        justify-content: space-between;
        flex-wrap: wrap;
        align-items: center;
        padding-top: 20px;
        padding-bottom: 20px;
        padding-left: 25px;
        padding-right: 15px;

        .information {
          margin-bottom: 20px;
          position: relative;
          padding-right: 50px;
          img {
            position: absolute;
            right: 0px;
            top: 0px;
          }
          h1 {
            @include apply-font($almarai, 400, 14px, #1ab1c7);
            margin-bottom: 10px;
          }
          h3 {
            @include apply-font($almarai, 400, 14px, $v3-medium-primarytext);
          }
        }
      }
    }

    .information-tile {
      width: 282px;
      height: 162px;
      border-radius: 13px;
      position: relative;
      @include applyGradientBorderMediumV3;
      box-shadow: 17px 27px 44px rgba(0, 0, 0, 0.04);
      margin-left: 30px;
      margin-bottom: 30px;

      &:nth-child(4n) {
        margin-left: 0;
      }

      .tilehead {
        height: 67px;
        background: $v3-medium-header-color;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        border-radius: 13px 13px 0px 0px;
        box-shadow: 0px 11px 81px rgba(0, 0, 0, 0.26);

        img {
          margin-left: 15px;
          margin-right: 15px;
        }

        h1 {
          @include apply-font($almarai, 400, 14px, $v3-medium-primarytext);
        }

        h1:last-child {
          margin-bottom: 0px;
        }
      }
      .content-container {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        height: 100px;
        text-align: center;

        p {
          @include apply-font($almarai, 600, 19px, $v3-medium-primarytext);
          margin-bottom: 0;
        }
        p.last {
          @include apply-font($almarai, 600, 13px, $v3-medium-primarytext);
        }
      }
    }
  }
  .tiles-section {
    display: flex;
    justify-content: space-between;
    padding-top: 25px;
    padding-bottom: 32px;
    border-bottom: 1px dashed $v3-medium-dashed-seperator;

    .lg-tile-proto {
      width: 648px;
      height: 260px;
      border-radius: 13px;
      position: relative;
      @include applyGradientBorderMediumV3;
      box-shadow: 17px 27px 44px rgba(0, 0, 0, 0.04);

      .tilehead {
        height: 67px;
        background: $v3-medium-header-color;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        border-radius: 13px 13px 0px 0px;
        box-shadow: 0px 11px 81px rgba(0, 0, 0, 0.26);

        img {
          margin-left: 15px;
          margin-right: 15px;
        }

        h1 {
          @include apply-font($almarai, 400, 14px, $v3-medium-primarytext);
        }

        h1:last-child {
          margin-bottom: 0px;
        }
      }

      .content-container {
        display: inline-flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 20px;
        padding-bottom: 20px;
        padding-left: 25px;
        padding-right: 15px;

        .chart-holder {
          max-width: 153px;
          max-height: 140px;
          margin-right: 50px;
        }
        .tile-icon {
          img {
            margin-right: 30px;
          }
        }

        .tile-proto {
          width: 130px;
          height: 153px;
          border-radius: 13px;
          display: flex;
          align-items: center;
          flex-direction: column;
          position: relative;
          @include applyGradientBorderMediumV3;
          box-shadow: 17px 27px 44px rgba(0, 0, 0, 0.04);
          margin-left: 20px;

          img {
            margin-top: 0px;
          }

          h1 {
            @include apply-font($almarai, 700, 13px, #527a7a);
            margin-bottom: 0px;
            margin-top: 0px;
          }

          h2 {
            @include apply-font($sourcesanspro, 700, 33px, #1ab1c7);
            margin-bottom: 0px;
            margin-top: 15px;
          }

          h2.small {
            font-size: 19px !important;
            margin-top: 20px;
          }

          h2.purple {
            color: #1ab1c7 !important;
          }

          h2.green {
            color: #47bf8e !important;
          }
        }
        .list-holder.block {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .list.block {
          margin-right: 50px;
          padding-right: 20px;
          img {
            position: static;
            margin-bottom: 5px;
          }
        }

        .list {
          height: 70px;
          display: flex;
          justify-content: center;
          align-items: flex-start;
          flex-direction: column;
          position: relative;
          padding-right: 62px;
          margin-right: 50px;

          &:first-child {
            margin-top: 10px;
          }

          img {
            position: absolute;
            right: 0px;
            top: 15px;
          }
          img.first {
            right: 8px;
          }

          h1 {
            // letter-spacing: 1.91px;
            @include apply-font($almarai, 700, 13px, #1ab1c7);
            margin-bottom: 6px;
          }

          h2 {
            @include apply-font(
              $sourcesanspro,
              300,
              16px,
              $v3-medium-primarytext
            );
            margin-bottom: 10px;
          }

          h2.blue {
            color: #1ab1c7 !important;
          }
        }

        .list.border-b {
          border-bottom: 1px solid rgba(0, 156, 181, 0.13);
        }
      }
    }
  }
  .milestones,
  .deliverables {
    height: 500px;
    padding-top: 25px;
    padding-bottom: 32px;
    border-bottom: 1px dashed $v3-medium-dashed-seperator;
    overflow:auto;
    .current-filters {
      margin-right: 20px;
      .active-filter {
        @include apply-font($almarai, 700, 14px, $v3-medium-primarytext);
        border: 1px solid #000;
        border-radius: 17.56px;
        padding: 8px 20px;
      }
      img {
        cursor: pointer;
        margin-top: 10px;
        margin-right: 20px;
      }
    }

    .table-title {
      @include apply-font($almarai, 300, 18px, $v3-medium-primarytext);
      margin-bottom: 36px;
      img {
        height: 25px;
        margin-left: 20px;
      }
    }

    .table-tiles {
      width: 142px;
      height: 67px;
      border-radius: 13px;
      position: relative;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      padding-top: 5px;
      // padding-bottom: 10px;
      margin-left: 28px;
      cursor: pointer;
      @include applyGradientBorderMediumV3;
      box-shadow: 17px 27px 44px rgba(0, 0, 0, 0.04);

      &.table-tiles.active {
        background: linear-gradient(152.47deg, #ffffff 0.74%, #89fdff 97.97%)
            padding-box,
          linear-gradient(
              140deg,
              rgba(12, 46, 46, 0.1),
              rgba(255, 255, 255, 0),
              rgba(17, 53, 53, 0.17)
            )
            border-box;
        box-shadow: 0px 27px 35px rgba(0, 0, 0, 0.13);
      }

      img.icon {
        position: absolute;
        right: 20px;
        top: 15px;
      }

      h1 {
        @include apply-font($almarai, 400, 14px, $v3-medium-primarytext);
        margin-right: 18px;
      }

      h2 {
        @include apply-font($sourcesanspro, 600, 26px, $v3-medium-primarytext);
        margin-right: 18px;
      }
    }

    .table-tiles.last {
      margin-left: 0;
    }

    .milestone-table,
    .deliverable-table {
      width: 96%;
      margin-top: 60px;

      thead {
        tr {
          background: #1978b2;
          height: 45px;
          // height: 63px;

          th {
            @include apply-font($almarai, 700, 12px, #fff);
          }
          th:first-child {
            padding-right: 10px;
          }

          th.center {
            text-align: center;
          }
        }
      }

      tbody {
        tr {
          height: 63px;
        }

        tr:nth-child(odd) {
          background: $v3-medium-table-stripes;
        }

        tr {
          td {
            @include apply-font($almarai, 400, 12px, $v3-medium-primarytext);
          }

          td:first-child {
            padding-right: 10px;
          }

          td.date,
          td.span {
            @include apply-font($almarai, 700, 12px, $v3-medium-primarytext);
          }

          td span {
            padding: 2px 25px;
            border-radius: 4px;
            color: $v3-medium-primarytext;
            white-space: nowrap;
          }

          td span.high {
            background: $v3-high;
          }

          td span.medium {
            background: $v3-medium;
          }

          td span.low {
            background: $v3-low;
          }
          td span.late {
            background: $v3-late;
          }

          td span.expectedlate {
            background: $v3-expectedlate;
          }

          td span.onplanned {
            background: $v3-onplanned;
          }
          td span.completed {
            background: $v3-completed;
          }

          td.center {
            text-align: center;
          }
        }
      }
    }
  }

  .deliverables {
    .table-tiles {
      img.icon {
        top: 20px;
      }
    }
  }
  .risks {
    padding-top: 25px;
    padding-bottom: 32px;
    border-bottom: 1px dashed $v3-medium-dashed-seperator;

    .table-title {
      @include apply-font($almarai, 700, 18px, $v3-medium-primarytext);
      margin-bottom: 36px;
    }

    .table-tiles {
      width: 142px;
      height: 67px;
      border-radius: 13px;
      position: relative;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      padding-top: 5px;
      // padding-bottom: 10px;
      margin-left: 28px;
      cursor: pointer;
      @include applyGradientBorderMediumV3;
      box-shadow: 17px 27px 44px rgba(0, 0, 0, 0.04);

      &.table-tiles.active {
        background: linear-gradient(152.47deg, #ffffff 0.74%, #89fdff 97.97%)
            padding-box,
          linear-gradient(
              140deg,
              rgba(12, 46, 46, 0.1),
              rgba(255, 255, 255, 0),
              rgba(17, 53, 53, 0.17)
            )
            border-box;
        box-shadow: 0px 27px 35px rgba(0, 0, 0, 0.13);
      }

      img.icon {
        position: absolute;
        right: 20px;
        top: 15px;
      }

      h1 {
        @include apply-font($almarai, 400, 14px, $v3-medium-primarytext);
        margin-right: 18px;
      }

      h2 {
        @include apply-font($sourcesanspro, 600, 26px, $v3-medium-primarytext);
        margin-right: 18px;
      }
    }

    .table-tiles.last {
      margin-left: 0;
    }

    .risk-table,
    .issue-table {
      width: 96%;
      margin-top: 60px;
      max-height: 693px;
      overflow: auto;

      thead {
        tr {
          height: 63px;

          th {
            @include apply-font($almarai, 700, 12px, $v3-medium-primarytext);
          }

          th.center {
            text-align: center;
          }
        }
      }

      tbody {
        tr {
          height: 63px;
        }

        tr:nth-child(odd) {
          background: $v3-medium-table-stripes;
        }

        tr:nth-child(even) {
          background: $v3-medium-table-stripes-even;
        }

        tr {
          td {
            @include apply-font($almarai, 400, 12px, $v3-medium-primarytext);
          }

          td:first-child {
            padding-right: 10px;
          }

          td.date,
          td.span {
            @include apply-font($almarai, 700, 12px, $v3-medium-primarytext);
          }

          td span {
            padding: 2px 25px;
            border-radius: 4px;
            color: #fff;
            white-space: nowrap;
          }

          td span.high {
            background: #ff6565;
          }

          td span.medium {
            background: #fa9963;
          }

          td span.low {
            background: #84ff90;
          }

          td.center {
            text-align: center;
          }
        }
      }
    }
  }
}
.theme-light.ar {
  .information-tiles-section {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding-top: 25px;
    padding-bottom: 32px;
    border-bottom: 1px dashed $v3-light-dashed-seperator;

    .lg-tile-proto {
      width: 648px;
      height: 260px;
      border-radius: 13px;
      position: relative;
      @include applyGradientBorderV3;
      box-shadow: 17px 27px 44px rgba(0, 0, 0, 0.04);

      .tilehead {
        height: 67px;
        background: $v3-light-header-color;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        border-radius: 13px 13px 0px 0px;
        box-shadow: 0px 11px 81px rgba(0, 0, 0, 0.26);

        img {
          margin-left: 15px;
          margin-right: 15px;
        }

        h1 {
          @include apply-font($almarai, 400, 14px, $v3-light-primarytext);
        }

        h1:last-child {
          margin-bottom: 0px;
        }
      }

      .content-container {
        display: inline-flex;
        justify-content: space-between;
        flex-wrap: wrap;
        align-items: center;
        padding-top: 20px;
        padding-bottom: 20px;
        padding-left: 25px;
        padding-right: 15px;

        .information {
          margin-bottom: 20px;
          position: relative;
          padding-right: 50px;
          img {
            position: absolute;
            right: 0px;
            top: 0px;
          }
          h1 {
            @include apply-font($almarai, 400, 14px, #1ab1c7);
            margin-bottom: 10px;
          }
          h3 {
            @include apply-font($almarai, 400, 14px, $v3-light-primarytext);
           
          }
        }
      }
    }

    .information-tile {
      width: 282px;
      height: 162px;
      border-radius: 13px;
      position: relative;
      @include applyGradientBorder;
      box-shadow: 17px 27px 44px rgba(0, 0, 0, 0.04);
      margin-left: 30px;
      margin-bottom: 30px;

      &:nth-child(4n) {
        margin-left: 0;
      }

      .tilehead {
        height: 67px;
        background: $v3-light-header-color;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        border-radius: 13px 13px 0px 0px;
        box-shadow: 0px 11px 81px rgba(0, 0, 0, 0.26);

        img {
          margin-left: 15px;
          margin-right: 15px;
        }

        h1 {
          @include apply-font($almarai, 400, 14px, $v3-light-primarytext);
        }

        h1:last-child {
          margin-bottom: 0px;
        }
      }
      .content-container {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        height: 100px;
        text-align: center;

        p {
          @include apply-font($almarai, 600, 19px, $v3-light-primarytext);
          margin-bottom: 0;
        }
        p.last {
          @include apply-font($almarai, 600, 13px, $v3-light-primarytext);
        }
      }
    }
  }
  .tiles-section {
    display: flex;
    justify-content: space-between;
    padding-top: 25px;
    padding-bottom: 32px;
    border-bottom: 1px dashed $v3-light-dashed-seperator;

    .lg-tile-proto {
      width: 648px;
      height: 260px;
      border-radius: 13px;
      position: relative;
      @include applyGradientBorder;
      box-shadow: 17px 27px 44px rgba(0, 0, 0, 0.04);

      .tilehead {
        height: 67px;
        background: $v3-light-header-color;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        border-radius: 13px 13px 0px 0px;
        box-shadow: 0px 11px 81px rgba(0, 0, 0, 0.26);

        img {
          margin-left: 15px;
          margin-right: 15px;
        }

        h1 {
          @include apply-font($almarai, 400, 14px, $v3-light-primarytext);
        }

        h1:last-child {
          margin-bottom: 0px;
        }
      }

      .content-container {
        display: inline-flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 20px;
        padding-bottom: 20px;
        padding-left: 25px;
        padding-right: 15px;

        .chart-holder {
          max-width: 153px;
          max-height: 140px;
          margin-right: 50px;
        }
        .tile-icon {
          img {
            margin-right: 30px;
          }
        }

        .tile-proto {
          width: 130px;
          height: 153px;
          border-radius: 13px;
          display: flex;
          align-items: center;
          flex-direction: column;
          position: relative;
          @include applyGradientBorder;
          box-shadow: 17px 27px 44px rgba(0, 0, 0, 0.04);
          margin-left: 20px;

          img {
            margin-top: 0px;
          }

          h1 {
            @include apply-font($almarai, 700, 13px, #527a7a);
            margin-bottom: 0px;
            margin-top: 0px;
          }

          h2 {
            @include apply-font($sourcesanspro, 700, 33px, #1ab1c7);
            margin-bottom: 0px;
            margin-top: 15px;
          }

          h2.small {
            font-size: 19px !important;
            margin-top: 20px;
          }

          h2.purple {
            color: #1ab1c7 !important;
          }

          h2.green {
            color: #47bf8e !important;
          }
        }
        .list-holder.block {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .list.block {
          margin-right: 50px;
          padding-right: 20px;
          img {
            position: static;
            margin-bottom: 5px;
          }
        }

        .list {
          height: 70px;
          display: flex;
          justify-content: center;
          align-items: flex-start;
          flex-direction: column;
          position: relative;
          padding-right: 62px;
          margin-right: 50px;

          &:first-child {
            margin-top: 10px;
          }

          img {
            position: absolute;
            right: 0px;
            top: 15px;
          }
          img.first {
            right: 8px;
          }

          h1 {
            // letter-spacing: 1.91px;
            @include apply-font($almarai, 700, 13px, #1ab1c7);
            margin-bottom: 6px;
          }

          h2 {
            @include apply-font(
              $sourcesanspro,
              300,
              16px,
              $v3-light-primarytext
            );
            margin-bottom: 10px;
          }

          h2.blue {
            color: #1ab1c7 !important;
          }
        }

        .list.border-b {
          border-bottom: 1px solid rgba(0, 156, 181, 0.13);
        }
      }
    }
  }
  .milestones,
  .deliverables {
    height:500px;
    padding-top: 25px;
    padding-bottom: 32px;
    border-bottom: 1px dashed $v3-light-dashed-seperator;
    overflow: auto;
    .current-filters {
      margin-right: 20px;
      .active-filter {
        @include apply-font($almarai, 700, 14px, $v3-light-primarytext);
        border: 1px solid #000;
        border-radius: 17.56px;
        padding: 8px 20px;
      }
      img {
        cursor: pointer;
        margin-top: 10px;
        margin-right: 20px;
      }
    }

    .table-title {
      @include apply-font($almarai, 300, 18px, $v3-light-primarytext);
      margin-bottom: 36px;
      img {
        height: 25px;
        margin-left: 20px;
      }
    }

    .table-tiles {
      width: 142px;
      height: 67px;
      border-radius: 13px;
      position: relative;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      padding-top: 5px;
      // padding-bottom: 10px;
      margin-left: 28px;
      cursor: pointer;
      @include applyGradientBorder;
      box-shadow: 17px 27px 46px rgba(0, 0, 0, 0.04);

      &.table-tiles.active {
        background: linear-gradient(
              152.47deg,
              rgba(0, 186, 190, 0.09) 0.74%,
              rgba(0, 186, 190, 0) 97.97%
            )
            padding-box,
          linear-gradient(
              140deg,
              rgba(12, 46, 46, 0.1),
              rgba(255, 255, 255, 0),
              rgba(17, 53, 53, 0.17)
            )
            border-box;
        box-shadow: 0px 27px 35px rgba(0, 0, 0, 0.13);
      }

      img.icon {
        position: absolute;
        right: 20px;
        top: 15px;
      }

      h1 {
        @include apply-font($almarai, 400, 14px, #103c64);
        margin-right: 18px;
      }

      h2 {
        @include apply-font($sourcesanspro, 600, 26px, #103c64);
        margin-right: 18px;
      }
    }

    .table-tiles.last {
      margin-left: 0;
    }

    .milestone-table,
    .deliverable-table {
      width: 96%;
      margin-top: 60px;

      thead {
        tr {
          background: #1978b2;
          height: 45px;
          // height: 63px;

          th {
            @include apply-font($almarai, 700, 12px, #fff);
          }
          th:first-child {
            padding-right: 10px;
          }

          th.center {
            text-align: center;
          }
        }
      }

      tbody {
        tr {
          height: 63px;
        }

        tr:nth-child(odd) {
          background: $v3-light-table-stripes;
        }

        tr {
          td {
            @include apply-font($almarai, 400, 12px, $v3-light-primarytext);
          }

          td:first-child {
            padding-right: 10px;
          }

          td.date,
          td.span {
            @include apply-font($almarai, 700, 12px, $v3-light-primarytext);
          }

          td span {
            padding: 2px 25px;
            border-radius: 4px;
            color: $v3-light-primarytext;
            white-space: nowrap;
          }

          td span.high {
            background: $v3-high;
          }

          td span.medium {
            background: $v3-medium;
          }

          td span.low {
            background: $v3-low;
          }
          td span.late {
            background: $v3-late;
          }

          td span.expectedlate {
            background: $v3-expectedlate;
          }

          td span.onplanned {
            background: $v3-onplanned;
          }
          td span.completed {
            background: $v3-completed;
          }

          td.center {
            text-align: center;
          }
        }
      }
    }
  }

  .deliverables {
    .table-tiles {
      img.icon {
        top: 20px;
      }
    }
  }

  .risks {
    padding-top: 25px;
    padding-bottom: 32px;
    border-bottom: 1px dashed $v3-light-dashed-seperator;

    .table-title {
      @include apply-font($almarai, 700, 18px, #103c64);
      margin-bottom: 36px;
    }

    .table-tiles {
      width: 142px;
      height: 67px;
      border-radius: 13px;
      position: relative;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      padding-top: 5px;
      // padding-bottom: 10px;
      margin-left: 28px;
      cursor: pointer;
      @include applyGradientBorder;
      box-shadow: 17px 27px 46px rgba(0, 0, 0, 0.04);

      &.table-tiles.active {
        background: linear-gradient(
              152.47deg,
              rgba(0, 186, 190, 0.09) 0.74%,
              rgba(0, 186, 190, 0) 97.97%
            )
            padding-box,
          linear-gradient(
              140deg,
              rgba(12, 46, 46, 0.1),
              rgba(255, 255, 255, 0),
              rgba(17, 53, 53, 0.17)
            )
            border-box;
        box-shadow: 0px 27px 35px rgba(0, 0, 0, 0.13);
      }

      img.icon {
        position: absolute;
        right: 20px;
        top: 15px;
      }

      h1 {
        @include apply-font($almarai, 400, 14px, #103c64);
        margin-right: 18px;
      }

      h2 {
        @include apply-font($sourcesanspro, 600, 26px, #103c64);
        margin-right: 18px;
      }
    }

    .table-tiles.last {
      margin-left: 0;
    }

    .risk-table,
    .issue-table {
      width: 96%;
      margin-top: 60px;
      max-height: 693px;
      overflow: auto;

      thead {
        tr {
          height: 63px;

          th {
            @include apply-font($almarai, 700, 12px, #103c64);
          }

          th.center {
            text-align: center;
          }
        }
      }

      tbody {
        tr {
          height: 63px;
        }

        tr:nth-child(odd) {
          background: $v3-light-table-stripes;
        }

        tr {
          td {
            @include apply-font($almarai, 400, 12px, #103c64);
          }

          td:first-child {
            padding-right: 10px;
          }

          td.date,
          td.span {
            @include apply-font($almarai, 700, 12px, #103c64);
          }

          td span {
            padding: 2px 25px;
            border-radius: 4px;
            color: #fff;
            white-space: nowrap;
          }

          td span.high {
            background: #ff6565;
          }

          td span.medium {
            background: #fa9963;
          }

          td span.low {
            background: #84ff90;
          }

          td.center {
            text-align: center;
          }
        }
      }
    }
  }
}

.theme-dark.en {
  .information-tiles-section {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding-top: 25px;
    padding-bottom: 32px;
    border-bottom: 1px dashed $v3-dark-dashed-seperator;

    .lg-tile-proto {
      width: 648px;
      height: 260px;
      border-radius: 13px;
      position: relative;
      @include applyGradientBorderDarkV3;
      box-shadow: 0px 11px 81px rgba(0, 0, 0, 0.26);

      .tilehead {
        height: 67px;
        background: $v3-dark-header-color;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        border-radius: 13px 13px 0px 0px;
        box-shadow: 0px 11px 81px rgba(0, 0, 0, 0.26);

        img {
          margin-left: 15px;
          margin-right: 15px;
        }

        h1 {
          @include apply-font($sourcesanspro, 400, 14px, $v3-dark-primarytext);
        }

        h1:last-child {
          margin-bottom: 0px;
        }
      }

      .content-container {
        display: inline-flex;
        justify-content: space-between;
        flex-wrap: wrap;
        align-items: center;
        padding-top: 20px;
        padding-bottom: 20px;
        padding-left: 25px;
        padding-right: 15px;

        .information {
          margin-bottom: 20px;
          position: relative;
          padding-left: 50px;
          img {
            position: absolute;
            left: 0px;
            top: 0px;
          }
          h1 {
            @include apply-font($sourcesanspro, 400, 14px, #1ab1c7);
            margin-bottom: 10px;
          }
          h3 {
            @include apply-font(
              $sourcesanspro,
              400,
              14px,
              $v3-dark-primarytext
            );
            
          }
        }
      }
    }

    .information-tile {
      width: 282px;
      height: 162px;
      border-radius: 13px;
      position: relative;
      @include applyGradientBorderDarkV3;
      box-shadow: 0px 11px 81px rgba(0, 0, 0, 0.26);
      margin-right: 30px;
      margin-bottom: 30px;

      &:nth-child(4n) {
        margin-right: 0;
      }

      .tilehead {
        height: 67px;
        background: $v3-dark-header-color;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        border-radius: 13px 13px 0px 0px;
        box-shadow: 0px 11px 81px rgba(0, 0, 0, 0.26);

        img {
          margin-right: 15px;
        }

        h1 {
          @include apply-font($sourcesanspro, 400, 14px, $v3-dark-primarytext);
        }

        h1:last-child {
          margin-bottom: 0px;
        }
      }
      .content-container {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        height: 100px;
        text-align: center;

        p {
          @include apply-font($sourcesanspro, 600, 19px, $v3-dark-primarytext);
          margin-bottom: 0;
        }
        p.last {
          @include apply-font($sourcesanspro, 600, 13px, $v3-dark-primarytext);
        }
      }
    }
  }
  .tiles-section {
    display: flex;
    justify-content: space-between;
    padding-top: 25px;
    padding-bottom: 32px;
    border-bottom: 1px dashed $v3-dark-dashed-seperator;

    .lg-tile-proto {
      width: 648px;
      height: 260px;
      border-radius: 13px;
      position: relative;
      @include applyGradientBorderDarkV3;
      box-shadow: 0px 11px 81px rgba(0, 0, 0, 0.26);

      .tilehead {
        height: 67px;
        background: $v3-dark-header-color;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        border-radius: 13px 13px 0px 0px;
        box-shadow: 0px 11px 81px rgba(0, 0, 0, 0.26);

        img {
          margin-left: 15px;
          margin-right: 15px;
        }

        h1 {
          @include apply-font($almarai, 400, 14px, $v3-dark-primarytext);
        }

        h1:last-child {
          margin-bottom: 0px;
        }
      }

      .content-container {
        display: inline-flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 20px;
        padding-bottom: 20px;
        padding-left: 25px;
        padding-right: 15px;

        .chart-holder {
          max-width: 153px;
          max-height: 140px;
          margin-left: 50px;
        }
        .tile-icon {
          img {
            margin-left: 30px;
          }
        }

        .tile-proto {
          width: 130px;
          height: 153px;
          border-radius: 13px;
          display: flex;
          align-items: center;
          flex-direction: column;
          position: relative;
          @include applyGradientBorderDarkV3;
          box-shadow: 0px 11px 81px rgba(0, 0, 0, 0.26);
          margin-left: 20px;

          img {
            margin-top: 0px;
          }

          h1 {
            @include apply-font($almarai, 700, 13px, #527a7a);
            margin-bottom: 0px;
            margin-top: 0px;
          }

          h2 {
            @include apply-font($sourcesanspro, 700, 33px, #1ab1c7);
            margin-bottom: 0px;
            margin-top: 15px;
          }

          h2.small {
            font-size: 19px !important;
            margin-top: 20px;
          }

          h2.purple {
            color: #1ab1c7 !important;
          }

          h2.green {
            color: #47bf8e !important;
          }
        }
        .list-holder.block {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-right: 20px;
        }
        .list.block {
          margin-left: 30px;
          margin-right: 0;
          padding-left: 20px;
          img {
            position: static;
            margin-bottom: 5px;
          }
        }

        .list {
          height: 70px;
          display: flex;
          justify-content: center;
          align-items: flex-start;
          flex-direction: column;
          position: relative;
          padding-left: 62px;
          margin-right: 40px;

          &:first-child {
            margin-top: 10px;
          }

          img {
            position: absolute;
            left: 25px;
            top: 15px;
          }
          img.first {
            right: 8px;
          }

          h1 {
            // letter-spacing: 1.91px;
            @include apply-font($almarai, 700, 13px, #1ab1c7);
            margin-bottom: 6px;
          }

          h2 {
            @include apply-font($sourcesanspro, 300, 16px, #fff);
            margin-bottom: 10px;
          }

          h2.blue {
            color: #1ab1c7 !important;
          }
        }

        .list.border-b {
          border-bottom: 1px solid rgba(0, 156, 181, 0.13);
        }
      }
    }
  }
  .milestones,
  .deliverables {
    height: 500px;
    padding-top: 25px;
    padding-bottom: 32px;
    border-bottom: 1px dashed $v3-dark-dashed-seperator;
    overflow: auto;
    .current-filters {
      margin-left: 20px;
      .active-filter {
        @include apply-font($almarai, 700, 14px, $v3-dark-primarytext);
        border: 1px solid #fff;
        border-radius: 17.56px;
        padding: 8px 20px;
      }
      img {
        cursor: pointer;
        margin-top: 10px;
        margin-left: 20px;
      }
    }

    .table-title {
      @include apply-font($sourcesanspro, 300, 18px, $v3-dark-primarytext);
      margin-bottom: 36px;
      img {
        height: 25px;
        margin-right: 20px;
      }
    }

    .table-tiles {
      width: 142px;
      height: 67px;
      border-radius: 13px;
      position: relative;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      padding-top: 5px;
      // padding-bottom: 10px;
      margin-right: 28px;
      cursor: pointer;
      @include applyGradientBorderDarkV3;
      box-shadow: 0px 11px 81px rgba(0, 0, 0, 0.26);

      &.table-tiles.active {
        background: linear-gradient(
              152.47deg,
              $v3-dark-header-color 0.74%,
              #20384b 97.97%
            )
            padding-box,
          linear-gradient(
              140deg,
              rgba(171, 227, 227, 1),
              rgba(6, 26, 26, 0),
              rgba(170, 214, 214, 1)
            )
            border-box;
        box-shadow: 0px 11px 81px rgba(0, 0, 0, 0.83);
      }

      img.icon {
        position: absolute;
        left: 20px;
        top: 15px;
      }

      h1 {
        @include apply-font($sourcesanspro, 400, 14px, $v3-dark-primarytext);
        margin-left: 18px;
      }

      h2 {
        @include apply-font($sourcesanspro, 600, 26px, $v3-dark-primarytext);
        margin-left: 18px;
      }
    }

    .table-tiles.last {
      margin-right: 0;
    }

    .milestone-table,
    .deliverable-table {
      width: 96%;
      margin-top: 60px;

      thead {
        tr {
          background: #1978b2;
          height: 63px;

          th {
            @include apply-font($almarai, 700, 12px, #fff);
          }
          th:first-child {
            padding-left: 10px;
          }

          th.center {
            text-align: center;
          }
        }
      }

      tbody {
        tr {
          height: 63px;
        }

        tr:nth-child(odd) {
          background: $v3-dark-table-stripes;
        }

        tr {
          td {
            @include apply-font($almarai, 400, 12px, $v3-dark-primarytext);
          }

          td:first-child {
            padding-right: 10px;
          }

          td.date,
          td.span {
            @include apply-font($almarai, 700, 12px, $v3-dark-primarytext);
          }

          td span {
            padding: 2px 25px;
            border-radius: 4px;
            color: #fff;
            white-space: nowrap;
          }

          td span.high {
            background: $v3-high;
          }

          td span.medium {
            background: $v3-medium;
          }

          td span.low {
            background: $v3-low;
          }
          td span.late {
            background: $v3-late;
          }

          td span.expectedlate {
            background: $v3-expectedlate;
          }

          td span.onplanned {
            background: $v3-onplanned;
          }
          td span.completed {
            background: $v3-completed;
          }

          td.center {
            text-align: center;
          }
        }
      }
    }
  }

  .deliverables {
    .table-tiles {
      img.icon {
        top: 20px;
      }
    }
  }

  .risks {
    padding-top: 25px;
    padding-bottom: 32px;
    border-bottom: 1px dashed $v3-dark-dashed-seperator;

    .table-title {
      @include apply-font($sourcesanspro, 700, 18px, $v3-dark-primarytext);
      margin-bottom: 36px;
    }

    .table-tiles {
      width: 142px;
      height: 67px;
      border-radius: 13px;
      position: relative;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      padding-top: 5px;
      // padding-bottom: 10px;
      margin-right: 28px;
      cursor: pointer;
      @include applyGradientBorderDarkV3;
      box-shadow: 0px 11px 81px rgba(0, 0, 0, 0.26);

      &.table-tiles.active {
        background: linear-gradient(
              152.47deg,
              $v3-dark-header-color 0.74%,
              #20384b 97.97%
            )
            padding-box,
          linear-gradient(
              140deg,
              rgba(171, 227, 227, 1),
              rgba(6, 26, 26, 0),
              rgba(170, 214, 214, 1)
            )
            border-box;
        box-shadow: 0px 11px 81px rgba(0, 0, 0, 0.83);
      }

      img.icon {
        position: absolute;
        left: 20px;
        top: 15px;
      }

      h1 {
        @include apply-font($sourcesanspro, 400, 14px, $v3-dark-primarytext);
        margin-left: 18px;
      }

      h2 {
        @include apply-font($sourcesanspro, 600, 26px, $v3-dark-primarytext);
        margin-left: 18px;
      }
    }

    .table-tiles.last {
      margin-right: 0;
    }

    .risk-table,
    .issue-table {
      width: 96%;
      margin-top: 60px;
      max-height: 693px;
      overflow: auto;

      thead {
        tr {
          height: 63px;

          th {
            @include apply-font($almarai, 700, 12px, #91b3ba);
          }

          th.center {
            text-align: center;
          }
        }
      }

      tbody {
        tr {
          height: 63px;
        }

        tr:nth-child(odd) {
          background: $v3-dark-header-color;
        }

        tr {
          td {
            @include apply-font($almarai, 400, 12px, $v3-dark-primarytext);
          }

          td:first-child {
            padding-left: 10px;
          }

          td.date,
          td.span {
            @include apply-font($almarai, 700, 12px, $v3-dark-primarytext);
          }

          td span {
            padding: 2px 25px;
            border-radius: 4px;
            color: #fff;
            white-space: nowrap;
          }

          td span.high {
            background: #ff6565;
          }

          td span.medium {
            background: #fa9963;
          }

          td span.low {
            background: #84ff90;
          }

          td.center {
            text-align: center;
          }
        }
      }
    }
  }
}
.theme-medium.en {
  .information-tiles-section {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding-top: 25px;
    padding-bottom: 32px;
    border-bottom: 1px dashed $v3-medium-dashed-seperator;

    .lg-tile-proto {
      width: 648px;
      height: 260px;
      border-radius: 13px;
      position: relative;
      @include applyGradientBorderMediumV3;
      box-shadow: 0px 11px 81px rgba(0, 0, 0, 0.04);

      .tilehead {
        height: 67px;
        background: $v3-medium-header-color;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        border-radius: 13px 13px 0px 0px;
        box-shadow: 0px 11px 81px rgba(0, 0, 0, 0.26);

        img {
          margin-left: 15px;
          margin-right: 15px;
        }

        h1 {
          @include apply-font(
            $sourcesanspro,
            400,
            14px,
            $v3-medium-primarytext
          );
        }

        h1:last-child {
          margin-bottom: 0px;
        }
      }

      .content-container {
        display: inline-flex;
        justify-content: space-between;
        flex-wrap: wrap;
        align-items: center;
        padding-top: 20px;
        padding-bottom: 20px;
        padding-left: 25px;
        padding-right: 15px;

        .information {
          margin-bottom: 20px;
          position: relative;
          padding-left: 50px;
          img {
            position: absolute;
            left: 0px;
            top: 0px;
          }
          h1 {
            @include apply-font($sourcesanspro, 400, 14px, #1ab1c7);
            margin-bottom: 10px;
          }
          h3 {
            @include apply-font(
              $sourcesanspro,
              400,
              14px,
              $v3-medium-primarytext
            );
           
          }
        }
      }
    }

    .information-tile {
      width: 282px;
      height: 162px;
      border-radius: 13px;
      position: relative;
      @include applyGradientBorderMediumV3;
      box-shadow: 17px 27px 44px rgba(0, 0, 0, 0.04);
      margin-right: 30px;
      margin-bottom: 30px;

      &:nth-child(4n) {
        margin-right: 0;
      }

      .tilehead {
        height: 67px;
        background: $v3-medium-header-color;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        border-radius: 13px 13px 0px 0px;
        box-shadow: 0px 11px 81px rgba(0, 0, 0, 0.26);

        img {
          margin-right: 15px;
        }

        h1 {
          @include apply-font(
            $sourcesanspro,
            400,
            14px,
            $v3-medium-primarytext
          );
        }

        h1:last-child {
          margin-bottom: 0px;
        }
      }
      .content-container {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        height: 100px;
        text-align: center;

        p {
          @include apply-font(
            $sourcesanspro,
            600,
            19px,
            $v3-medium-primarytext
          );
          margin-bottom: 0;
        }
        p.last {
          @include apply-font(
            $sourcesanspro,
            600,
            13px,
            $v3-medium-primarytext
          );
        }
      }
    }
  }
  .tiles-section {
    display: flex;
    justify-content: space-between;
    padding-top: 25px;
    padding-bottom: 32px;
    border-bottom: 1px dashed $v3-medium-dashed-seperator;

    .lg-tile-proto {
      width: 648px;
      height: 260px;
      border-radius: 13px;
      position: relative;
      @include applyGradientBorderMediumV3;
      box-shadow: 17px 27px 44px rgba(0, 0, 0, 0.04);

      .tilehead {
        height: 67px;
        background: $v3-medium-header-color;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        border-radius: 13px 13px 0px 0px;
        box-shadow: 0px 11px 81px rgba(0, 0, 0, 0.26);

        img {
          margin-left: 15px;
          margin-right: 15px;
        }

        h1 {
          @include apply-font($almarai, 400, 14px, $v3-medium-primarytext);
        }

        h1:last-child {
          margin-bottom: 0px;
        }
      }

      .content-container {
        display: inline-flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 20px;
        padding-bottom: 20px;
        padding-left: 25px;
        padding-right: 15px;

        .chart-holder {
          max-width: 153px;
          max-height: 140px;
          margin-left: 50px;
        }
        .tile-icon {
          img {
            margin-left: 30px;
          }
        }

        .tile-proto {
          width: 130px;
          height: 153px;
          border-radius: 13px;
          display: flex;
          align-items: center;
          flex-direction: column;
          position: relative;
          @include applyGradientBorderMediumV3;
          box-shadow: 17px 27px 44px rgba(0, 0, 0, 0.04);
          margin-left: 20px;

          img {
            margin-top: 0px;
          }

          h1 {
            @include apply-font($almarai, 700, 13px, #527a7a);
            margin-bottom: 0px;
            margin-top: 0px;
          }

          h2 {
            @include apply-font($sourcesanspro, 700, 33px, #1ab1c7);
            margin-bottom: 0px;
            margin-top: 15px;
          }

          h2.small {
            font-size: 19px !important;
            margin-top: 20px;
          }

          h2.purple {
            color: #1ab1c7 !important;
          }

          h2.green {
            color: #47bf8e !important;
          }
        }
        .list-holder.block {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-right: 20px;
        }
        .list.block {
          margin-left: 30px;
          margin-right: 0;
          padding-left: 20px;
          img {
            position: static;
            margin-bottom: 5px;
          }
        }

        .list {
          height: 70px;
          display: flex;
          justify-content: center;
          align-items: flex-start;
          flex-direction: column;
          position: relative;
          padding-left: 62px;
          margin-right: 40px;

          &:first-child {
            margin-top: 10px;
          }

          img {
            position: absolute;
            left: 25px;
            top: 15px;
          }
          img.first {
            right: 8px;
          }

          h1 {
            // letter-spacing: 1.91px;
            @include apply-font($almarai, 700, 13px, #1ab1c7);
            margin-bottom: 6px;
          }

          h2 {
            @include apply-font($sourcesanspro, 300, 16px, #fff);
            margin-bottom: 10px;
          }

          h2.blue {
            color: #1ab1c7 !important;
          }
        }

        .list.border-b {
          border-bottom: 1px solid rgba(0, 156, 181, 0.13);
        }
      }
    }
  }
  .milestones,
  .deliverables {
    height: 500px;
    padding-top: 25px;
    padding-bottom: 32px;
    border-bottom: 1px dashed $v3-medium-dashed-seperator;
    overflow: auto;
    .current-filters {
      margin-left: 20px;
      .active-filter {
        @include apply-font($almarai, 700, 14px, $v3-medium-primarytext);
        border: 1px solid #000;
        border-radius: 17.56px;
        padding: 8px 20px;
      }
      img {
        cursor: pointer;
        margin-top: 10px;
        margin-left: 20px;
      }
    }

    .table-title {
      @include apply-font($sourcesanspro, 300, 18px, $v3-medium-primarytext);
      margin-bottom: 36px;
      img {
        height: 25px;
        margin-right: 20px;
      }
    }

    .table-tiles {
      width: 142px;
      height: 67px;
      border-radius: 13px;
      position: relative;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      padding-top: 5px;
      // padding-bottom: 10px;
      margin-right: 28px;
      cursor: pointer;
      @include applyGradientBorderMediumV3;
      box-shadow: 17px 27px 44px rgba(0, 0, 0, 0.04);

      &.table-tiles.active {
        background: linear-gradient(152.47deg, #ffffff 0.74%, #89fdff 97.97%)
            padding-box,
          linear-gradient(
              140deg,
              rgba(12, 46, 46, 0.1),
              rgba(255, 255, 255, 0),
              rgba(17, 53, 53, 0.17)
            )
            border-box;
        box-shadow: 0px 27px 35px rgba(0, 0, 0, 0.13);
      }

      img.icon {
        position: absolute;
        right: 20px;
        top: 15px;
      }

      h1 {
        @include apply-font($sourcesanspro, 400, 14px, $v3-medium-primarytext);
        margin-right: 18px;
      }

      h2 {
        @include apply-font($sourcesanspro, 600, 26px, $v3-medium-primarytext);
        margin-right: 18px;
      }
    }

    .table-tiles.last {
      margin-right: 0;
    }

    .milestone-table,
    .deliverable-table {
      width: 96%;
      margin-top: 60px;

      thead {
        tr {
          height: 63px;

          th {
            @include apply-font($almarai, 700, 12px, #91b3ba);
          }
          th:first-child {
            padding-left: 10px;
          }

          th.center {
            text-align: center;
          }
        }
      }

      tbody {
        tr {
          height: 63px;
        }

        tr:nth-child(odd) {
          background: $v3-medium-table-stripes;
        }

        tr {
          td {
            @include apply-font($almarai, 400, 12px, $v3-medium-primarytext);
          }

          td:first-child {
            padding-right: 10px;
          }

          td.date,
          td.span {
            @include apply-font($almarai, 700, 12px, $v3-medium-primarytext);
          }

          td span {
            padding: 2px 25px;
            border-radius: 4px;
            color: #fff;
            white-space: nowrap;
          }

          td span.high {
            background: $v3-high;
          }

          td span.medium {
            background: $v3-medium;
          }

          td span.low {
            background: $v3-low;
          }
          td span.late {
            background: $v3-late;
          }

          td span.expectedlate {
            background: $v3-expectedlate;
          }

          td span.onplanned {
            background: $v3-onplanned;
          }
          td span.completed {
            background: $v3-completed;
          }

          td.center {
            text-align: center;
          }
        }
      }
    }
  }

  .deliverables {
    .table-tiles {
      img.icon {
        top: 20px;
      }
    }
  }
  .risks {
    padding-top: 25px;
    padding-bottom: 32px;
    border-bottom: 1px dashed $v3-medium-dashed-seperator;

    .table-title {
      @include apply-font($sourcesanspro, 700, 18px, $v3-medium-primarytext);
      margin-bottom: 36px;
    }

    .table-tiles {
      width: 142px;
      height: 67px;
      border-radius: 13px;
      position: relative;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      padding-top: 5px;
      // padding-bottom: 10px;
      margin-right: 28px;
      cursor: pointer;
      @include applyGradientBorderMediumV3;
      box-shadow: 17px 27px 44px rgba(0, 0, 0, 0.04);

      &.table-tiles.active {
        background: linear-gradient(152.47deg, #ffffff 0.74%, #89fdff 97.97%)
            padding-box,
          linear-gradient(
              140deg,
              rgba(12, 46, 46, 0.1),
              rgba(255, 255, 255, 0),
              rgba(17, 53, 53, 0.17)
            )
            border-box;
        box-shadow: 0px 27px 35px rgba(0, 0, 0, 0.13);
      }

      img.icon {
        position: absolute;
        right: 20px;
        top: 15px;
      }

      h1 {
        @include apply-font($sourcesanspro, 400, 14px, $v3-medium-primarytext);
        margin-right: 18px;
      }

      h2 {
        @include apply-font($sourcesanspro, 600, 26px, $v3-medium-primarytext);
        margin-right: 18px;
      }
    }

    .table-tiles.last {
      margin-right: 0;
    }

    .risk-table,
    .issue-table {
      width: 96%;
      margin-top: 60px;
      max-height: 693px;
      overflow: auto;

      thead {
        tr {
          height: 63px;

          th {
            @include apply-font($almarai, 700, 12px, $v3-medium-primarytext);
          }

          th.center {
            text-align: center;
          }
        }
      }

      tbody {
        tr {
          height: 63px;
        }

        tr:nth-child(odd) {
          background: $v3-medium-table-stripes;
        }

        tr:nth-child(even) {
          background: $v3-medium-table-stripes-even;
        }

        tr {
          td {
            @include apply-font($almarai, 400, 12px, $v3-medium-primarytext);
          }

          td:first-child {
            padding-left: 10px;
          }

          td.date,
          td.span {
            @include apply-font(
              $sourcesanspro,
              700,
              12px,
              $v3-medium-primarytext
            );
          }

          td span {
            padding: 2px 25px;
            border-radius: 4px;
            color: #fff;
            white-space: nowrap;
          }

          td span.high {
            background: #ff6565;
          }

          td span.medium {
            background: #fa9963;
          }

          td span.low {
            background: #84ff90;
          }

          td.center {
            text-align: center;
          }
        }
      }
    }
  }
}
.theme-light.en {
  .information-tiles-section {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding-top: 25px;
    padding-bottom: 32px;
    border-bottom: 1px dashed $v3-light-dashed-seperator;

    .lg-tile-proto {
      width: 648px;
      height: 260px;
      border-radius: 13px;
      position: relative;
      @include applyGradientBorderV3;
      box-shadow: 0px 11px 81px rgba(0, 0, 0, 0.04);

      .tilehead {
        height: 67px;
        background: $v3-light-header-color;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        border-radius: 13px 13px 0px 0px;
        box-shadow: 0px 11px 81px rgba(0, 0, 0, 0.26);

        img {
          margin-left: 15px;
          margin-right: 15px;
        }

        h1 {
          @include apply-font($sourcesanspro, 400, 14px, $v3-light-primarytext);
        }

        h1:last-child {
          margin-bottom: 0px;
        }
      }

      .content-container {
        display: inline-flex;
        justify-content: space-between;
        flex-wrap: wrap;
        align-items: center;
        padding-top: 20px;
        padding-bottom: 20px;
        padding-left: 25px;
        padding-right: 15px;

        .information {
          margin-bottom: 20px;
          position: relative;
          padding-left: 50px;
          img {
            position: absolute;
            left: 0px;
            top: 0px;
          }
          h1 {
            @include apply-font($sourcesanspro, 400, 14px, #1ab1c7);
            margin-bottom: 10px;
          }
          h3 {
            @include apply-font(
              $sourcesanspro,
              400,
              14px,
              $v3-light-primarytext
            );
           
          }
        }
      }
    }

    .information-tile {
      width: 282px;
      height: 162px;
      border-radius: 13px;
      position: relative;
      @include applyGradientBorder;
      box-shadow: 17px 27px 44px rgba(0, 0, 0, 0.04);
      margin-right: 30px;
      margin-bottom: 30px;

      &:nth-child(4n) {
        margin-right: 0;
      }

      .tilehead {
        height: 67px;
        background: $v3-light-header-color;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        border-radius: 13px 13px 0px 0px;
        box-shadow: 0px 11px 81px rgba(0, 0, 0, 0.26);

        img {
          margin-right: 15px;
        }

        h1 {
          @include apply-font($sourcesanspro, 400, 14px, $v3-light-primarytext);
        }

        h1:last-child {
          margin-bottom: 0px;
        }
      }
      .content-container {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        height: 100px;
        text-align: center;

        p {
          @include apply-font($sourcesanspro, 600, 19px, $v3-light-primarytext);
          margin-bottom: 0;
        }
        p.last {
          @include apply-font($sourcesanspro, 600, 13px, $v3-light-primarytext);
        }
      }
    }
  }
  .tiles-section {
    display: flex;
    justify-content: space-between;
    padding-top: 25px;
    padding-bottom: 32px;
    border-bottom: 1px dashed $v3-light-dashed-seperator;

    .lg-tile-proto {
      width: 648px;
      height: 260px;
      border-radius: 13px;
      position: relative;
      @include applyGradientBorder;
      box-shadow: 17px 27px 44px rgba(0, 0, 0, 0.04);

      .tilehead {
        height: 67px;
        background: $v3-light-header-color;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        border-radius: 13px 13px 0px 0px;
        box-shadow: 0px 11px 81px rgba(0, 0, 0, 0.26);

        img {
          margin-left: 15px;
          margin-right: 15px;
        }

        h1 {
          @include apply-font($almarai, 400, 14px, $v3-light-primarytext);
        }

        h1:last-child {
          margin-bottom: 0px;
        }
      }

      .content-container {
        display: inline-flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 20px;
        padding-bottom: 20px;
        padding-left: 25px;
        padding-right: 15px;

        .chart-holder {
          max-width: 153px;
          max-height: 140px;
          margin-left: 50px;
        }
        .tile-icon {
          img {
            margin-left: 30px;
          }
        }

        .tile-proto {
          width: 130px;
          height: 153px;
          border-radius: 13px;
          display: flex;
          align-items: center;
          flex-direction: column;
          position: relative;
          @include applyGradientBorder;
          box-shadow: 17px 27px 44px rgba(0, 0, 0, 0.04);
          margin-left: 20px;

          img {
            margin-top: 0px;
          }

          h1 {
            @include apply-font($almarai, 700, 13px, #527a7a);
            margin-bottom: 0px;
            margin-top: 0px;
          }

          h2 {
            @include apply-font($sourcesanspro, 700, 33px, #1ab1c7);
            margin-bottom: 0px;
            margin-top: 15px;
          }

          h2.small {
            font-size: 19px !important;
            margin-top: 20px;
          }

          h2.purple {
            color: #1ab1c7 !important;
          }

          h2.green {
            color: #47bf8e !important;
          }
        }
        .list-holder.block {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-right: 20px;
        }
        .list.block {
          margin-left: 30px;
          margin-right: 0;
          padding-left: 20px;
          img {
            position: static;
            margin-bottom: 5px;
          }
        }

        .list {
          height: 70px;
          display: flex;
          justify-content: center;
          align-items: flex-start;
          flex-direction: column;
          position: relative;
          padding-left: 62px;
          margin-right: 40px;

          &:first-child {
            margin-top: 10px;
          }

          img {
            position: absolute;
            left: 25px;
            top: 15px;
          }
          img.first {
            right: 8px;
          }

          h1 {
            // letter-spacing: 1.91px;
            @include apply-font($almarai, 700, 13px, #1ab1c7);
            margin-bottom: 6px;
          }

          h2 {
            @include apply-font($sourcesanspro, 300, 16px, #fff);
            margin-bottom: 10px;
          }

          h2.blue {
            color: #1ab1c7 !important;
          }
        }

        .list.border-b {
          border-bottom: 1px solid rgba(0, 156, 181, 0.13);
        }
      }
    }
  }
  .milestones,
  .deliverables {
    height: 500px;
    padding-top: 25px;
    padding-bottom: 32px;
    border-bottom: 1px dashed $v3-light-dashed-seperator;
    overflow: auto;
    .current-filters {
      margin-left: 20px;
      .active-filter {
        @include apply-font($almarai, 700, 14px, $v3-light-primarytext);
        border: 1px solid #000;
        border-radius: 17.56px;
        padding: 8px 20px;
      }
      img {
        cursor: pointer;
        margin-top: 10px;
        margin-left: 20px;
      }
    }

    .table-title {
      @include apply-font($sourcesanspro, 300, 18px, $v3-light-primarytext);
      margin-bottom: 36px;
      img {
        height: 25px;
        margin-right: 20px;
      }
    }

    .table-tiles {
      width: 142px;
      height: 67px;
      border-radius: 13px;
      position: relative;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      padding-top: 5px;
      // padding-bottom: 10px;
      margin-right: 28px;
      cursor: pointer;
      @include applyGradientBorder;
      box-shadow: 17px 27px 46px rgba(0, 0, 0, 0.04);

      &.table-tiles.active {
        background: linear-gradient(
              152.47deg,
              rgba(0, 186, 190, 0.09) 0.74%,
              rgba(0, 186, 190, 0) 97.97%
            )
            padding-box,
          linear-gradient(
              140deg,
              rgba(12, 46, 46, 0.1),
              rgba(255, 255, 255, 0),
              rgba(17, 53, 53, 0.17)
            )
            border-box;
        box-shadow: 0px 27px 35px rgba(0, 0, 0, 0.13);
      }

      img.icon {
        position: absolute;
        right: 20px;
        top: 15px;
      }

      h1 {
        @include apply-font($sourcesanspro, 400, 14px, #103c64);
        margin-right: 18px;
      }

      h2 {
        @include apply-font($sourcesanspro, 600, 26px, #103c64);
        margin-right: 18px;
      }
    }

    .table-tiles.last {
      margin-right: 0;
    }

    .milestone-table,
    .deliverable-table {
      width: 96%;
      margin-top: 60px;

      thead {
        tr {
          height: 63px;

          th {
            @include apply-font($almarai, 700, 12px, #91b3ba);
          }
          th:first-child {
            padding-left: 10px;
          }

          th.center {
            text-align: center;
          }
        }
      }

      tbody {
        tr {
          height: 63px;
        }

        tr:nth-child(odd) {
          background: $v3-light-table-stripes;
        }

        tr {
          td {
            @include apply-font($almarai, 400, 12px, $v3-light-primarytext);
          }

          td:first-child {
            padding-right: 10px;
          }

          td.date,
          td.span {
            @include apply-font($almarai, 700, 12px, $v3-light-primarytext);
          }

          td span {
            padding: 2px 25px;
            border-radius: 4px;
            color: #fff;
            white-space: nowrap;
          }

          td span.high {
            background: $v3-high;
          }

          td span.medium {
            background: $v3-medium;
          }

          td span.low {
            background: $v3-low;
          }
          td span.late {
            background: $v3-late;
          }

          td span.expectedlate {
            background: $v3-expectedlate;
          }

          td span.onplanned {
            background: $v3-onplanned;
          }
          td span.completed {
            background: $v3-completed;
          }

          td.center {
            text-align: center;
          }
        }
      }
    }
  }

  .deliverables {
    .table-tiles {
      img.icon {
        top: 20px;
      }
    }
  }
  .risks {
    padding-top: 25px;
    padding-bottom: 32px;
    border-bottom: 1px dashed $v3-light-dashed-seperator;

    .table-title {
      @include apply-font($sourcesanspro, 700, 18px, #103c64);
      margin-bottom: 36px;
    }

    .table-tiles {
      width: 142px;
      height: 67px;
      border-radius: 13px;
      position: relative;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      padding-top: 5px;
      // padding-bottom: 10px;
      margin-right: 28px;
      cursor: pointer;
      @include applyGradientBorder;
      box-shadow: 17px 27px 46px rgba(0, 0, 0, 0.04);

      &.table-tiles.active {
        background: linear-gradient(
              152.47deg,
              rgba(0, 186, 190, 0.09) 0.74%,
              rgba(0, 186, 190, 0) 97.97%
            )
            padding-box,
          linear-gradient(
              140deg,
              rgba(12, 46, 46, 0.1),
              rgba(255, 255, 255, 0),
              rgba(17, 53, 53, 0.17)
            )
            border-box;
        box-shadow: 0px 27px 35px rgba(0, 0, 0, 0.13);
      }

      img.icon {
        position: absolute;
        right: 20px;
        top: 15px;
      }

      h1 {
        @include apply-font($sourcesanspro, 400, 14px, #103c64);
        margin-right: 18px;
      }

      h2 {
        @include apply-font($sourcesanspro, 600, 26px, #103c64);
        margin-right: 18px;
      }
    }

    .table-tiles.last {
      margin-right: 0;
    }

    .risk-table,
    .issue-table {
      width: 96%;
      margin-top: 60px;
      max-height: 693px;
      overflow: auto;

      thead {
        tr {
          height: 63px;

          th {
            @include apply-font($almarai, 700, 12px, #103c64);
          }

          th.center {
            text-align: center;
          }
        }
      }

      tbody {
        tr {
          height: 63px;
        }

        tr:nth-child(odd) {
          background: $v3-light-table-stripes;
        }

        tr {
          td {
            @include apply-font($almarai, 400, 12px, #103c64);
          }

          td:first-child {
            padding-left: 10px;
          }

          td.date,
          td.span {
            @include apply-font($almarai, 700, 12px, #103c64);
          }

          td span {
            padding: 2px 25px;
            border-radius: 4px;
            color: #fff;
            white-space: nowrap;
          }

          td span.high {
            background: #ff6565;
          }

          td span.medium {
            background: #fa9963;
          }

          td span.low {
            background: #84ff90;
          }

          td.center {
            text-align: center;
          }
        }
      }
    }
  }
}
</style>
